import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import React__default, { useMemo, memo, useState, useEffect } from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { Alert, Button, ShowroomModelIndicator, StockIndicator, Link, List, useGoogleMapsContext, Util as Util$1, MediaQuery, InfoWindow, useGoogleMapsStaticMap, QuickFilterButton, toast, Autocomplete, ProductOffers, Breadcrumbs } from '@grandvisionhq/common';
import { Location, Types, OpeningHours, withGetCoordinates, Address, useLocation, LocationSearchMap, LocationDistance, getOpenCloseStatus, getNormalOpenCloseStatusForDay, usePlacePredictions, mapPlacePredictionToSuggestion, LocationSearch, StoreTile, StoreTileSection, StoreTileImage } from '@grandvisionhq/locations';
import { useApiClient, Stores } from '@grandvisionhq/api-client';
import { SkeletonLoader, Text, Heading, Button as Button$1, Hr } from '@grandvisionhq/elements';
import { Form, Input, Select, Util } from '@grandvisionhq/forms';
import { withApiConfig, withIntl, useIntl, useFeatureToggles, useClickAndReserveFeatureConfig, useSelector } from '@grandvisionhq/state';
import { findNearestCoordinates, getDistance, formatDistance, slugify, QueryString, DistanceUnit, parseHtml, DateUtils, getDirectionsUrl, useSessionStorage, useDebouncedEffect, useAddViewportHeightCssVariable, getDisplayName, EnvironmentUtils } from '@grandvisionhq/utils';
import { DataLayer } from '@grandvisionhq/analytics';
import deburr from 'lodash/deburr';
import { createSlotsContext } from '@grandvisionhq/slots';
import { gql, useLazyQuery, useQuery, useMutation, Types as Types$1 } from '@grandvisionhq/graphql';
import { IsLoggedIn, Selectors } from '@grandvisionhq/auth';
import { throttle } from 'throttle-debounce';

const SimpleBreadcrumb = (_param)=>{
    var { className , title , href  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "title",
        "href"
    ]);
    const classes = classnames('store-simple-breadcrumb-stores-v2', className);
    const children = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "chevron-left"
    }), title);
    return href ? /*#__PURE__*/ React__default.createElement("a", swcHelpers.extends({}, rest, {
        href: href,
        className: classes
    }), children) : /*#__PURE__*/ React__default.createElement("p", swcHelpers.extends({}, rest, {
        className: classes
    }), children);
};

const StoreListItem = (_param)=> {
    var { className , store: { code , shortName , phone , emailAddress , storeNote , openingHours , specialOpeningHours  } , addressData , hidePhone , hideEmail , buttons , distance , onMouseEnter , onMouseLeave , onExpandOpeningHoursCallback , storeDetailsUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "store",
        "addressData",
        "hidePhone",
        "hideEmail",
        "buttons",
        "distance",
        "onMouseEnter",
        "onMouseLeave",
        "onExpandOpeningHoursCallback",
        "storeDetailsUrl"
    ]);
    return React__default.createElement(Location, swcHelpers.extends({}, rest, {
        className: classnames('store-list-item-stores-v2', className),
        key: code,
        id: code,
        name: shortName,
        variant: Types.LocationVariant.ListItem,
        emailAddress: emailAddress,
        phone: phone,
        emailHidden: hideEmail,
        phoneHidden: hidePhone,
        highlight: false,
        addressData: addressData,
        note: /*#__PURE__*/ React__default.createElement(Alert, {
            type: "info",
            icon: "information-circle",
            message: storeNote
        }),
        openingHours: /*#__PURE__*/ React__default.createElement(OpeningHours, {
            onExpandCallback: onExpandOpeningHoursCallback,
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours
        }),
        buttons: buttons,
        formattedDistance: distance,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        locationDetailsUrl: storeDetailsUrl
    }));
};

const StoreListTopContent = (_param)=> {
    var { title , description , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "description",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-list-top-content-stores-v2', className)
    }), title && /*#__PURE__*/ React__default.createElement("h2", {
        className: "h3"
    }, title), description && /*#__PURE__*/ React__default.createElement("p", {
        "data-t": "store-list-top-content-description"
    }, description));
};

const getSvgString$1 = (width, height, theme)=>`<svg width="${width}px" height="${height}px" fill="none" viewBox="0 0 56 66" xmlns="http://www.w3.org/2000/svg"><ellipse cx="28" cy="55.944" rx="7.5158" ry="1.4" fill="${theme.borderColor}" opacity=".4"/><g filter="url(#a)"><path d="m45.537 24.08c0 9.4115-12.706 24.9-16.846 29.343-0.3765 0.4041-1.0051 0.4041-1.3815 0-4.1399-4.4435-16.846-19.932-16.846-29.343 0-10.021 7.8515-17.537 17.537-17.537 9.6854 0 17.537 7.5158 17.537 17.537z" fill="${theme.background}" /><path d="m29.422 54.106c2.1016-2.2557 6.3492-7.2823 10.079-12.94 1.8653-2.8297 3.6145-5.8377 4.9005-8.7507 1.2794-2.8982 2.1352-5.7796 2.1352-8.3344 0-10.586-8.3118-18.537-18.537-18.537-10.225 0-18.537 7.951-18.537 18.537 0 2.5548 0.85581 5.4362 2.1352 8.3344 1.2859 2.913 3.0352 5.921 4.9004 8.7507 3.7295 5.6577 7.9772 10.684 10.079 12.94 0.7719 0.8285 2.073 0.8285 2.8449 0z" stroke="#2B2E31" stroke-width="2"/></g><path d="m34.516 19.027-6.5626 12.578v-5.3908c0-0.3451-0.2798-0.625-0.625-0.625h-5.3907l12.578-6.5625zm0.1691-1.4981c0.3814-0.1978 0.847-0.1257 1.1508 0.1781s0.3759 0.7694 0.1782 1.1509l-8e-4 0.0015-7.4501 14.279c-0.2103 0.4018-0.6679 0.609-1.1085 0.5011-0.4405-0.1079-0.7505-0.5024-0.7513-0.9559v-5.8445h-5.8444c-0.4536-7e-4 -0.8481-0.3108-0.956-0.7513s0.0986-0.8978 0.5005-1.1081l14.28-7.4505 0.0015-7e-4z" clip-rule="evenodd" fill="${theme.borderColor}" fill-rule="evenodd"/><defs><filter id="a" x="1.4629" y=".54364" width="53.073" height="65.183" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3"/><feGaussianBlur stdDeviation="3.5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_19113:15839"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_19113:15839" result="shape"/></filter></defs></svg>`
;
const CurrentLocationPin = ({ width: defaultWidth = 56 , height: defaultHeight = 66 , theme  })=>()=>{
        const width = theme.width || defaultWidth;
        const height = theme.height || defaultHeight;
        const anchor = {
            x: Math.round(width / 2),
            y: height
        };
        const size = {
            width,
            height
        };
        const svgString = getSvgString$1(width, height, theme);
        return {
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
            anchor,
            size,
            scaledSize: size
        };
    }
;

const getSvgString = (width, height, pinColors)=>`<svg width="${width}" height="${height}" viewBox="0 0 56 60" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse opacity="0.4" cx="28.5" cy="54.8625" rx="7.65" ry="1.425" fill="#2B2E31"/><g filter="url(#filter0_dd_655_11904)"><path d="M46.7001 21.85C46.7001 31.233 34.2926 46.5499 29.8235 51.4249C29.2917 52.005 28.4084 52.005 27.8765 51.4249C23.4075 46.5499 11 31.233 11 21.85C11 11.65 18.9917 4 28.85 4C38.7083 4 46.7001 11.65 46.7001 21.85Z" fill="${pinColors.background}"/><path d="M30.5607 52.1007C32.824 49.6318 37.0789 44.5407 40.7752 38.8743C42.6238 36.0406 44.3457 33.0431 45.6084 30.1432C46.865 27.2575 47.7001 24.3943 47.7001 21.85C47.7001 11.0852 39.248 3 28.85 3C18.452 3 10 11.0852 10 21.85C10 24.3943 10.8351 27.2575 12.0917 30.1432C13.3544 33.0431 15.0763 36.0406 16.9248 38.8743C20.6212 44.5407 24.8761 49.6318 27.1394 52.1007C28.0676 53.1131 29.6325 53.1131 30.5607 52.1007Z" stroke="${pinColors.foreground}" stroke-width="2"/></g><g clip-path="url(#clip0_655_11904)"><path d="M37.4257 16.3226C35.1379 14.3729 31.7354 14.7236 29.6355 16.8904L28.813 17.7378L27.9906 16.8904C25.8948 14.7236 22.4882 14.3729 20.2004 16.3226C17.5786 18.5603 17.4408 22.5765 19.7871 25.002L27.8654 33.3433C28.3872 33.8818 29.2347 33.8818 29.7565 33.3433L37.8348 25.002C40.1852 22.5765 40.0475 18.5603 37.4257 16.3226Z" fill="${pinColors.foreground}"/></g><defs><filter id="filter0_dd_655_11904" x="5" y="0" width="47.7001" height="59.8601" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="2"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_655_11904"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/><feBlend mode="normal" in2="effect1_dropShadow_655_11904" result="effect2_dropShadow_655_11904"/><feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_655_11904" result="shape"/></filter><clipPath id="clip0_655_11904"><rect width="21.375" height="21.375" fill="${pinColors.background}" transform="translate(18.125 13.9749)"/></clipPath></defs></svg>`
;
const fallbackThemes = {
    primary: {
        foreground: '#ffffff',
        background: '#1e7be2'
    },
    highlight: {
        foreground: '#ffffff',
        background: '#1862b5'
    },
    hovered: {
        foreground: '#1e7be2',
        background: '#ffffff'
    }
};
const defaultOptions = {
    width: 40,
    height: 47,
    themes: fallbackThemes
};
const PreferredStorePin = (options = defaultOptions)=>({ hovered , highlight  })=>{
        var _width;
        const width = (_width = options.width) !== null && _width !== void 0 ? _width : defaultOptions.width;
        var _height;
        const height = (_height = options.height) !== null && _height !== void 0 ? _height : defaultOptions.height;
        var _themes;
        const themes = (_themes = options.themes) !== null && _themes !== void 0 ? _themes : defaultOptions.themes;
        const anchor = {
            x: Math.round(width / 2),
            y: height
        };
        const size = {
            width,
            height
        };
        const theme = (()=>{
            if (hovered) {
                return themes.hovered;
            }
            if (highlight) {
                return themes.highlight;
            }
            return themes.primary;
        })();
        const svgString = getSvgString(width, height, theme);
        return {
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
            anchor,
            size,
            scaledSize: size
        };
    }
;

const cityRegex = /^([a-zA-Z_\s\-]*)$/;
class PreferredStoreFinder extends React.Component {
    componentDidMount() {
        this.countries = this.getDistinctCountries();
    }
    static getDerivedStateFromProps({ selected , stores  }, prevState) {
        var ref;
        if (!prevState.search && selected && (selected === null || selected === void 0 ? void 0 : selected.code) !== ((ref = prevState.stores.selected) === null || ref === void 0 ? void 0 : ref.code)) {
            // Initialize state from props if user hasn't searched
            return swcHelpers.objectSpread({}, prevState, {
                isNoResults: false,
                location: selected,
                stores: {
                    selected,
                    list: findNearestCoordinates(selected, stores, {
                        limit: 10
                    })
                }
            });
        }
        return null;
    }
    render() {
        const { intl  } = this.props;
        const { search , stores , isNoResults , isTouched  } = this.state;
        const { list  } = stores;
        if (!this.props.stores.length) {
            return /*#__PURE__*/ React.createElement(Alert, {
                type: "error",
                message: intl.getLabel('stores.preferredStore.errorMessage')
            });
        }
        const isValid = this.isPostalCodeOrCity(search) && isTouched;
        const isInvalid = !this.isPostalCodeOrCity(search) && isTouched;
        const inputClasses = classnames('form-control__input', 'preferred-store-finder__input', {
            _is_valid: isValid,
            _is_invalid: isInvalid
        });
        return /*#__PURE__*/ React.createElement("article", {
            className: "preferred-store-finder"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__main"
        }, isNoResults && /*#__PURE__*/ React.createElement(Alert, {
            type: "info",
            message: intl.getLabel('stores.preferredStore.noResults')
        }), /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__search"
        }, /*#__PURE__*/ React.createElement("label", {
            className: "form-control__label"
        }, intl.getLabel('stores.preferredStore.search.label'), /*#__PURE__*/ React.createElement("span", {
            className: "form-control__asterisk"
        }, "*")), /*#__PURE__*/ React.createElement(Form, {
            name: "preferred-store-finder",
            onSubmit: this.handleClickCTA,
            className: "preferred-store-finder__search-form"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__search-form-content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__input-wrapper"
        }, /*#__PURE__*/ React.createElement(Input, {
            id: "search",
            "data-t": "search",
            className: inputClasses,
            placeholder: intl.getLabel('stores.form.findStore.fields.location.placeholder'),
            onChange: this.handleSearchChange,
            onBlur: this.handleBlur
        }), !this.isPostalCodeOrCity(search) && isTouched && /*#__PURE__*/ React.createElement("span", {
            className: "form-control__error"
        }, intl.getLabel('checkout.address.city.errorMessage'))), /*#__PURE__*/ React.createElement(Button, {
            className: "preferred-store-finder__button",
            color: "secondary",
            type: "submit",
            variant: !search || !this.isPostalCodeOrCity(search) ? 'outline' : 'solid',
            caption: intl.getLabel('stores.preferredStore.cta'),
            onClick: this.handleClickCTA
        })))), list.length > 0 && /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__result"
        }, /*#__PURE__*/ React.createElement("label", {
            className: "form-control"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "form-control__label"
        }, intl.getLabel('stores.preferredStore.result.label')), /*#__PURE__*/ React.createElement(Select, {
            required: true,
            id: "result",
            name: "result",
            onChange: this.handleStoreSelect,
            options: this.getDropdownOptions(intl.distanceUnit)
        })))));
    }
    checkForPostalCode(search) {
        const postCodeRegex = Util.validations.getPostalCodeRegex(this.props.intl.country);
        return (postCodeRegex === null || postCodeRegex === void 0 ? void 0 : postCodeRegex.test(search)) ? `postcode ${search}` : search;
    }
    constructor(...args){
        super(...args);
        this.state = {
            search: '',
            isNoResults: false,
            stores: {
                list: []
            }
        };
        this.countries = [];
        this.getDropdownOptions = (distanceUnit)=>{
            const { location , stores  } = this.state;
            let options = {};
            stores.list.map((item)=>{
                const { town , streetName , streetNumber , code: value  } = item;
                const distance = getDistance(location || {}, item);
                let label = `${town} - ${streetName}`;
                if (streetNumber) {
                    label += ` ${streetNumber}`;
                }
                if (distance !== Infinity) {
                    label += ` (± ${formatDistance(distance, distanceUnit, {
                        precision: 0
                    })})`;
                }
                options = swcHelpers.objectSpread({}, options, {
                    [label]: value
                });
            });
            return options;
        };
        this.handleBlur = ()=>{
            if (!this.state.isTouched) {
                this.setState({
                    isTouched: true
                });
            }
        };
        this.handleSearchChange = ({ value: search  })=>this.setState({
                search,
                isNoResults: false
            })
        ;
        this.handleStoreSelect = (value)=>{
            const { onStoreSelect  } = this.props;
            const { list  } = this.state.stores;
            const store = list.find((item)=>item.code === Number(value)
            );
            if (!store) {
                return;
            }
            onStoreSelect(store);
        };
        var _this = this;
        this.handleClickCTA = swcHelpers.asyncToGenerator(function*() {
            const { search  } = _this.state;
            if (!search || !_this.isPostalCodeOrCity(search)) {
                return;
            }
            const result = yield _this.getCoordinatesResult(_this.checkForPostalCode(search));
            if (!result) {
                return _this.setState({
                    isNoResults: true
                });
            }
            const l = result.coordinates;
            const location = {
                lat: l.lat,
                lon: l.lng
            };
            const list = findNearestCoordinates(location, _this.props.stores, {
                limit: 10
            });
            const selected = list[0];
            _this.setState({
                isNoResults: false,
                location,
                stores: {
                    selected,
                    list
                }
            }, ()=>_this.handleStoreSelect(selected.code)
            );
        });
        this.getDistinctCountries = ()=>{
            const { stores  } = this.props;
            const result = [];
            stores.forEach(({ country  })=>!result.includes(country) && result.push(country)
            );
            return result;
        };
        var _this1 = this;
        this.getCoordinatesResult = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(input) {
                const { apiConfig , getCoordinates  } = _this1.props;
                try {
                    return yield getCoordinates(apiConfig.locationsUrl, {
                        query: input
                    });
                } catch (e) {
                    console.error(e);
                }
            });
            return function(input) {
                return _ref.apply(this, arguments);
            };
        }();
        this.validateCity = (v)=>v.trim() ? cityRegex.test(v) : false
        ;
        this.isPostalCodeOrCity = (v)=>{
            return [
                Util.validations.getPostalCodeRegex(this.props.intl.country),
                this.validateCity
            ].some((validator)=>{
                return validator instanceof Function ? validator(v) : validator === null || validator === void 0 ? void 0 : validator.test(v);
            });
        };
    }
}
const PreferredStoreFinderLoader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "80px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "80%",
        height: "32px",
        rx: "4",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "50%",
        height: "32px",
        rx: "4",
        fill: "currentColor",
        y: "48"
    })));
};
const WithStores = (_param)=>{
    var { apiConfig  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "apiConfig"
    ]);
    const [isLoading, stores, error] = useApiClient(Stores.list, null, apiConfig.storesUrl);
    if (error) {
        throw error;
    }
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(PreferredStoreFinderLoader, null);
    }
    return /*#__PURE__*/ React.createElement(PreferredStoreFinder, swcHelpers.extends({
        stores: stores || [],
        apiConfig: apiConfig
    }, rest));
};
WithStores.displayName = 'WithStores(PreferredStoreFinder)';
var PreferredStoreFinder$1 = withGetCoordinates(withApiConfig(withIntl(WithStores)));

const StoreFinderItem = (_param)=>{
    var { className , distance , variant , title , addressData , addressSize , stockIndicatorData , children , disabled =false , icon  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "distance",
        "variant",
        "title",
        "addressData",
        "addressSize",
        "stockIndicatorData",
        "children",
        "disabled",
        "icon"
    ]);
    const renderDistanceNextToTitle = distance && (variant === 'list-item' || variant === 'map-item' && addressSize !== 'MINIMAL');
    const renderDistanceNextToAddress = variant === 'map-item' && distance && addressSize === 'MINIMAL';
    const { status , quantity , showroomModelAvailable , showroomModelAvailableLabel  } = stockIndicatorData !== null && stockIndicatorData !== void 0 ? stockIndicatorData : {};
    const renderOnlyShowroomModelIndicator = showroomModelAvailable || showroomModelAvailable && quantity;
    return /*#__PURE__*/ React.createElement("button", swcHelpers.extends({}, rest, {
        disabled: disabled,
        className: classnames('stores-v2-store-finder-item', className, {
            'stores-v2-store-finder-item--list-item': variant === 'list-item',
            'stores-v2-store-finder-item--map-item': variant === 'map-item',
            'stores-v2-store-finder-item--disabled': disabled
        })
    }), icon ? /*#__PURE__*/ React.createElement("span", {
        className: "stores-v2-store-finder-item__icon"
    }, icon) : null, /*#__PURE__*/ React.createElement("span", {
        className: "stores-v2-store-finder-item__details"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "stores-v2-store-finder-item__header"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "stores-v2-store-finder-item__title"
    }, title), renderDistanceNextToTitle && /*#__PURE__*/ React.createElement(Text, {
        className: "stores-v2-store-finder-item__distance",
        variant: "caption"
    }, distance)), renderDistanceNextToAddress ? /*#__PURE__*/ React.createElement("div", {
        className: "stores-v2-store-finder-item__address-with-distance"
    }, /*#__PURE__*/ React.createElement(Address, {
        className: "stores-v2-store-finder-item__address",
        data: addressData,
        size: addressSize,
        prepend: `${distance} · `
    })) : /*#__PURE__*/ React.createElement(Address, {
        className: "stores-v2-store-finder-item__address",
        data: addressData,
        size: addressSize
    }), stockIndicatorData && status && /*#__PURE__*/ React.createElement(React.Fragment, null, renderOnlyShowroomModelIndicator ? /*#__PURE__*/ React.createElement(ShowroomModelIndicator, {
        label: showroomModelAvailableLabel !== null && showroomModelAvailableLabel !== void 0 ? showroomModelAvailableLabel : '',
        className: quantity && (status === 'IN_STOCK' || status === 'LOW_STOCK') ? 'common-showroommodel-indicator__in-stock' : ''
    }) : /*#__PURE__*/ React.createElement(StockIndicator, swcHelpers.extends({}, stockIndicatorData))), children), variant === 'map-item' && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
              .gm-style .gm-style-iw-c:hover,
              .gm-style-iw gm-style-iw-c:focus,
              .gm-style-iw gm-style-iw-c:active {
                color: var(--color--text-primary);
                border: 1px solid var(--color--button-outline-hover);
              }
              .gm-style .gm-style-iw-c {
                padding: 0 !important;
                border: 1px solid transparent;
              }
              .gm-style-iw-d {
                overflow: unset !important;
              }
              .click-and-reserve-store-finder .gm-style-iw-tc,
              .click-and-reserve-store-finder .gm-ui-hover-effect {
                display: none !important;
              }
            `), /*#__PURE__*/ React.createElement("span", {
        className: "stores-v2-store-finder-item__chevron"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right"
    }))));
};

var Sizes;
(function(Sizes) {
    Sizes[Sizes['small'] = 16] = 'small';
    Sizes[Sizes['medium'] = 24] = 'medium';
    Sizes[Sizes['large'] = 32] = 'large';
})(Sizes || (Sizes = {}));
var Colors;
(function(Colors) {
    Colors["gold"] = "gold";
    Colors["black"] = "black";
})(Colors || (Colors = {}));
const Star = ({ className , fill , color =Colors.gold , size  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-star', {
            'store-rating-star--empty': fill < 0.5,
            'store-rating-star--half': fill === 0.5,
            'store-rating-star--full': fill > 0.5,
            'store-rating-star__size--large': size === Sizes.large,
            'store-rating-star__size--medium': size === Sizes.medium,
            'store-rating-star__size--small': size === Sizes.small
        }, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-star__foreground', {
            'store-rating-star__foreground--default-color': color === Colors.gold,
            'store-rating-star__foreground--black': color === Colors.black
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__foreground-container"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "star",
        width: size,
        height: size
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__background"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "star",
        width: size,
        height: size
    })))
;

const Stars = ({ className , rating: rating1 , count =5 , size =Sizes.large , color ,  })=>{
    const getFill = (index, rating)=>{
        const ratingMinusOffset = Math.max(0, rating - index);
        const fill = Math.min(1, Math.round(ratingMinusOffset * 10 / (0.5 * 10)) * 0.5);
        return fill;
    };
    const array = React.useMemo(()=>Array.from({
            length: count
        })
    , [
        count
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-stars', className)
    }, array.map((_entry, index)=>/*#__PURE__*/ React.createElement(Star, {
            key: `star-${index}`,
            fill: getFill(index, rating1),
            size: size,
            color: color
        })
    ));
};

var StoreRating = (_param)=>{
    var { className , labels , rating , urls , onClickReview  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "rating",
        "urls",
        "onClickReview"
    ]);
     return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-rating', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: "store-rating__title",
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React.createElement(Stars, {
        color: Colors.gold,
        className: "store-rating__stars",
        rating: rating,
        "aria-hidden": true
    }), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__rating",
        variant: "body"
    }, labels.rating), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__rating-count",
        variant: "body"
    }, labels.ratingCount), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__description",
        variant: "body"
    }, labels.description), (urls === null || urls === void 0 ? void 0 : urls.review) && /*#__PURE__*/ React.createElement(Link, {
        className: "store-rating__review",
        url: urls.review,
        target: "_blank",
        onClick: onClickReview
    }, labels.review));
};

const PreferredStoreButton = ({ selected =false , onClick , labels  })=>/*#__PURE__*/ React.createElement("button", {
        className: "stores-v2-preferred-store-button",
        disabled: selected,
        onClick: !selected ? onClick : undefined
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: selected ? 'favourite-filled' : 'favourite-empty',
        className: selected ? 'stores-v2-preferred-store-button__icon--disabled' : ''
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        color: selected ? 'text-primary' : 'primary'
    }, selected ? labels.preferredStore : labels.setPreferredStore))
;

const HighlightPrefferedStore = ({ children , title  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "stores-v2-highlight-preferred-store"
    }, title ? /*#__PURE__*/ React.createElement(Heading, {
        component: "h5",
        variant: "subheading1"
    }, title) : null, children);
};

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SimpleBreadcrumb: SimpleBreadcrumb,
  StoreListItem: StoreListItem,
  StoreListTopContent: StoreListTopContent,
  CurrentLocationPin: CurrentLocationPin,
  PreferredStorePin: PreferredStorePin,
  PreferredStoreFinder: PreferredStoreFinder$1,
  StoreFinderItem: StoreFinderItem,
  StoreRating: StoreRating,
  PreferredStoreButton: PreferredStoreButton,
  HighlightPreferredStore: HighlightPrefferedStore
});

var _postalCode;
const storeDetailsEvent = ({ interaction , store  })=>({
        event: 'storeDetailsClick',
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction
            },
            store: {
                id: String(store.code),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode = store.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ''
            }
        }
    })
;
var _postalCode1;
const storeGroupEvent = ({ interaction , store , step , city  })=>({
        event: 'storeGroupClick',
        storeLocator: swcHelpers.objectSpread({
            action: swcHelpers.objectSpread({
                step,
                interaction
            }, city === undefined ? {} : {
                city
            })
        }, store === undefined ? {} : {
            store: {
                id: String(store.code),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode1 = store.postalCode) !== null && _postalCode1 !== void 0 ? _postalCode1 : ''
            }
        })
    })
;
var _postalCode2;
const storesLocatorResultEvent = ({ interaction , searchResults , searchPosition , store ,  })=>({
        event: 'storeSearchResults',
        storeLocator: {
            action: swcHelpers.objectSpread({
                step: 'store locator results',
                interaction
            }, searchResults === undefined ? {} : {
                searchResults
            }, searchPosition === undefined ? {} : {
                searchPosition
            }),
            store: {
                id: String(store.code),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode2 = store.postalCode) !== null && _postalCode2 !== void 0 ? _postalCode2 : ''
            }
        }
    })
;
const storeSearchSubmitEvent = ({ interaction , searchResults , location ,  })=>({
        event: 'storeSearchSubmit',
        storeLocator: {
            action: {
                step: 'store locator search',
                interaction,
                location,
                searchResults
            }
        }
    })
;
const storesSearchFilterEvent = ({ activeFilters , searchResults  })=>({
        event: 'storeSearchFilter',
        storeLocator: {
            action: {
                step: 'store filter',
                interaction: 'filter click',
                filterName: activeFilters.join(', '),
                searchResults: searchResults !== null && searchResults !== void 0 ? searchResults : null
            }
        }
    })
;

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeDetailsEvent: storeDetailsEvent,
  storeGroupEvent: storeGroupEvent,
  storesLocatorResultEvent: storesLocatorResultEvent,
  storeSearchSubmitEvent: storeSearchSubmitEvent,
  storesSearchFilterEvent: storesSearchFilterEvent
});

const createBreadcrumbs = (store, rootLabel, storesRoute)=>{
    if (!storesRoute) {
        console.error('createBreadcrumbs: Could not create breadcrumbs because storesRoute was not found');
        return [];
    }
    return [
        {
            name: 'Home',
            url: '/'
        },
        {
            name: rootLabel,
            url: storesRoute
        },
        {
            name: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbName : store.town,
            url: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbSlug : `${storesRoute}?search=${store.town}`
        },
        {
            name: `${store.name}`,
            url: `${storesRoute}/${store.slug}`
        }, 
    ];
};
const getBookAppointmentUrl = (bookAppointmentUrl, options)=>{
    return (store)=>{
        var ref, ref1;
        const { code  } = store;
        let result = bookAppointmentUrl;
        if ((options === null || options === void 0 ? void 0 : (ref = options.alternativeUrl) === null || ref === void 0 ? void 0 : ref.length) && (options === null || options === void 0 ? void 0 : (ref1 = options.alternativeUrlStores) === null || ref1 === void 0 ? void 0 : ref1.includes(code))) {
            result = options.alternativeUrl;
        }
        if (options === null || options === void 0 ? void 0 : options.paddedLength) {
            const storeId = String(code).padStart(options.paddedLength, '0');
            result = `${result}?storeId=${storeId}`;
        } else {
            result = `${result}?storeId=${code}`;
        }
        return result;
    };
};
var _slug;
const getStoreDetailUrl = (storesListUrl)=>(store)=>`${storesListUrl}/${slugify(store.town)}/${(_slug = store.slug) !== null && _slug !== void 0 ? _slug : store.code}`
;
const areServicesAvailable = (store, services)=>{
    var ref;
    return !(store === null || store === void 0 ? void 0 : (ref = store.servicesNotAvailable) === null || ref === void 0 ? void 0 : ref.some((notAvailable)=>services.includes(notAvailable)
    ));
};
const isEqualStores = (a, b)=>{
    if (a === b) {
        return true;
    }
    if (a.length !== b.length) {
        return false;
    }
    const codes = a.map(({ code  })=>code
    );
    for (const store of b){
        const index = codes.indexOf(store.code);
        if (index === -1) {
            return false;
        }
        codes.splice(index, 1);
    }
    return true;
};
const removeEmptyValues = (queryParams)=>Object.entries(queryParams).filter(([, value])=>value !== null && value !== undefined && value !== ''
    ).reduce((acc, [key, value])=>swcHelpers.objectSpread({}, acc, {
            [key]: value
        })
    , {})
;
var getStoreFinderUrlWithNewQueryParams = (newQueryParams)=>{
    const queryParams = QueryString.parse(window.location.search.substring(1));
    /** Remove old search and userLocation parameters before setting newQueryParams */ const restQueryParams = swcHelpers.objectWithoutProperties(queryParams, [
        "userLocation",
        "search"
    ]);
    /** Remove empty parameters to avoid having ?something=true&search= in url */ const params = swcHelpers.objectSpread({}, removeEmptyValues(restQueryParams), removeEmptyValues(newQueryParams));
    const isEmptyParams = Object.keys(params).length === 0;
    return `${window.location.pathname}${QueryString.stringify(params, isEmptyParams)}`;
};
const replaceStoreFinderUrlWithNewQueryParams = (newQueryParams)=>{
    window.history.replaceState(null, 'store-finder', getStoreFinderUrlWithNewQueryParams(newQueryParams));
};

const getAddressFromSuggestions = (suggestions, id)=>{
    const suggestion1 = suggestions.find((suggestion)=>suggestion.id === id
    );
    const { title ='' , subTitle  } = suggestion1 !== null && suggestion1 !== void 0 ? suggestion1 : {};
    return `${title}${subTitle ? ', ' + subTitle : ''}`;
};

const defaultSearchWhitelist = [
    'postalCode',
    'streetName',
    'town'
];
const normalize = (value)=>typeof value === 'string' || typeof value === 'number' ? deburr(value.toString()).toLowerCase() : ''
;
const searchStore = (store, query, searchWhitelist = defaultSearchWhitelist)=>{
    const normalizedQuery = normalize(query);
    return searchWhitelist.some((key)=>normalize(store[key]).includes(normalizedQuery)
    );
};

const getActiveCampaignBanner = (banner, { storeCode  })=>{
    if (!banner) {
        return;
    }
    if (!(banner === null || banner === void 0 ? void 0 : banner.startDate) || !(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
        return;
    }
    if (!(Date.now() > banner.startDate && Date.now() < banner.endDate)) {
        return;
    }
    // if there is no store specified we need to show the banner on all stores
    if (!banner.storesList) {
        return {
            url: banner.url,
            description: banner.description
        };
    }
    const list = banner.storesList.split(',');
    const storeNumberList = list.map((item)=>{
        const res = Number(item);
        if (isNaN(res)) {
            return;
        }
        return res;
    });
    const found = storeNumberList === null || storeNumberList === void 0 ? void 0 : storeNumberList.find((item)=>item === storeCode
    );
    if (found !== storeCode) {
        return;
    }
    return {
        url: banner.url,
        description: banner.description
    };
};

const getActiveStoreOffers = (availableProductCategories = [], storeProductCategories)=>{
    const enabledPerStore = storeProductCategories === null || storeProductCategories === void 0 ? void 0 : storeProductCategories.map(({ code  })=>code
    );
    return availableProductCategories.filter(({ key  })=>{
        return enabledPerStore === null || enabledPerStore === void 0 ? void 0 : enabledPerStore.includes(key);
    }).map(({ title , description , image , link  })=>{
        return {
            title,
            description,
            url: link,
            imageUrl: image === null || image === void 0 ? void 0 : image.url
        };
    });
};

const hasStock = (stock)=>!!stock && stock.status !== 'OUT_OF_STOCK' && stock.status !== 'UNKNOWN'
;

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createBreadcrumbs: createBreadcrumbs,
  getBookAppointmentUrl: getBookAppointmentUrl,
  getStoreDetailUrl: getStoreDetailUrl,
  areServicesAvailable: areServicesAvailable,
  isEqualStores: isEqualStores,
  removeEmptyValues: removeEmptyValues,
  getStoreFinderUrlWithNewQueryParams: getStoreFinderUrlWithNewQueryParams,
  replaceStoreFinderUrlWithNewQueryParams: replaceStoreFinderUrlWithNewQueryParams,
  getAddressFromSuggestions: getAddressFromSuggestions,
  searchStore: searchStore,
  getActiveCampaignBanner: getActiveCampaignBanner,
  getActiveStoreOffers: getActiveStoreOffers,
  hasStock: hasStock
});

const StoreBookAppointmentCTA = (_param)=> {
    var { className , labels , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "onClick"
    ]);
    return React__default.createElement(Button$1, swcHelpers.extends({}, rest, {
        className: classnames('store-book-appointment-cta-stores-v2', className),
        variant: "solid",
        onClick: onClick
    }), /*#__PURE__*/ React__default.createElement("span", {
        className: "store-book-appointment-cta-stores-v2__icon"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "calendar"
    })), labels.caption);
};

const StoreBookAppointmentCTAContainer = (_param)=>{
    var { url , code , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , storeCode , appointmentTypeId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "url",
        "code",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "storeCode",
        "appointmentTypeId"
    ]);
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const location = getBookAppointmentUrl(url, {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    })({
        code
    });
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            caption: getLabel('stores.page.details.action.bookAppointment')
        })
    , [
        getLabel
    ]);
    const onClick = React__default.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'book appointment click',
            store: {
                code,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        if (dataLayerEvent) {
            DataLayer.pushEvent(dataLayerEvent);
        }
        window.location.assign(location);
    }, [
        location,
        code,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode, 
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreBookAppointmentCTA, swcHelpers.extends({}, rest, {
        labels: labels,
        onClick: onClick
    }));
};

const StoreFacilities = (_param)=>{
    var { className , labels , facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "facilities"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-facilities-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React__default.createElement(List, {
        items: facilities,
        icon: "checkmark"
    }));
};

const StoreFacilitiesContainer = (_param)=>{
    var { facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "facilities"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.facilities.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreFacilities, swcHelpers.extends({
        labels: labels,
        facilities: facilities
    }, rest));
};

const storeFinderContextDefaultValues = {
    config: {
        googleMapsId: '',
        hidePhone: false,
        hideEmail: false,
        withUrlParams: false,
        storeFilter: ()=>true
    },
    stores: [],
    hoveredStore: null,
    isStoresLoading: false,
    isLocationSelected: false,
    searchQuery: '',
    suggestions: [],
    isPristineSearch: false,
    isUsingUserLocation: false,
    useUserLocationError: null,
    isUserLocationLoading: false,
    isUserLocationRequested: false,
    preferredStore: null,
    setIsUserLocationRequested: ()=>null
    ,
    clearSearch: ()=>null
    ,
    setSelectedLocation: ()=>null
    ,
    selectedLocation: '',
    setSuggestions: ()=>null
    ,
    setIsPristineSearch: ()=>null
    ,
    setStores: ()=>null
    ,
    setHoveredStore: ()=>null
    ,
    setSearchQuery: ()=>null
    ,
    setIsStoresLoading: ()=>null
    ,
    getStoreDetailsUrl: ()=>''
    ,
    setPreferredStore: ()=>null
};
const StoreFinderContext = /*#__PURE__*/ React__default.createContext(storeFinderContextDefaultValues);
const useStoreFinderContext = ()=>{
    const context = React__default.useContext(StoreFinderContext);
    if (context === storeFinderContextDefaultValues) {
        throw new Error('No StoreFinderContext available. You might still need to wrap the application with the StoreFinderProvider component.');
    }
    return context;
};
StoreFinderContext.displayName = 'StoreFinder';
const StoreFinderConsumer = StoreFinderContext.Consumer;

const StoreFinderProvider = ({ children , googleMapsId , hidePhone =false , hideEmail =false , withUrlParams =false , storeFilter =()=>true
 , initialStores , sku , events , searchQuery: initialSearchQuery , urls ,  })=>{
    const [stores, setStores] = React__default.useState(initialStores || []);
    const [hoveredStore, setHoveredStore] = React__default.useState(null);
    const [isStoresLoading, setIsStoresLoading] = React__default.useState(false);
    const [searchQuery, setSearchQuery] = React__default.useState(initialSearchQuery !== null && initialSearchQuery !== void 0 ? initialSearchQuery : '');
    const [isPristineSearch, setIsPristineSearch] = React__default.useState(initialStores ? false : true);
    const [suggestions, setSuggestions] = React__default.useState([]);
    const [selectedLocation, setSelectedLocation] = React__default.useState('');
    const [preferredStore, setPreferredStore] = React__default.useState(null);
    const { position: userLocation , isPositionLoading: isUserLocationLoading , isUseMyLocation: isUsingUserLocation , isMyLocationRequested: isUserLocationRequested , setIsMyLocationRequested: setIsUserLocationRequested , error: useUserLocationError ,  } = useLocation(false, {
        enableHighAccuracy: true,
        timeout: 10 * 1000,
        maximumAge: 0
    });
    const clearSearch = React__default.useCallback(()=>{
        setSearchQuery('');
        setSelectedLocation('');
        setSuggestions([]);
        setIsUserLocationRequested(false);
    }, [
        setSearchQuery,
        setSelectedLocation,
        setSuggestions,
        setIsUserLocationRequested
    ]);
    const getStoreDetailsUrl = React__default.useCallback((store)=>{
        if (!(urls === null || urls === void 0 ? void 0 : urls.storeDetails)) {
            console.error("getStoreDetailsUrl will not return a url because you didn't specify the localized storeDetails url");
            return '';
        }
        const storeDetailsUrlProvider = getStoreDetailUrl(urls === null || urls === void 0 ? void 0 : urls.storeDetails);
        return storeDetailsUrlProvider(store);
    }, [
        urls === null || urls === void 0 ? void 0 : urls.storeDetails
    ]);
    const config = React__default.useMemo(()=>({
            googleMapsId,
            hidePhone,
            hideEmail,
            withUrlParams,
            storeFilter
        })
    , [
        googleMapsId,
        hidePhone,
        hideEmail,
        withUrlParams,
        storeFilter
    ]);
    const values = React__default.useMemo(()=>({
            config,
            stores,
            hoveredStore,
            isLocationSelected: selectedLocation.length > 0,
            searchQuery: selectedLocation.length > 0 ? selectedLocation : searchQuery,
            isStoresLoading,
            isPristineSearch,
            suggestions,
            userLocation,
            isUsingUserLocation,
            useUserLocationError,
            isUserLocationRequested,
            setIsUserLocationRequested,
            isUserLocationLoading,
            clearSearch,
            getStoreDetailsUrl,
            setSelectedLocation,
            selectedLocation,
            setSuggestions,
            setIsPristineSearch,
            setSearchQuery,
            setStores,
            setHoveredStore,
            setIsStoresLoading,
            sku,
            events,
            preferredStore,
            setPreferredStore
        })
    , [
        config,
        stores,
        hoveredStore,
        selectedLocation,
        searchQuery,
        isStoresLoading,
        isPristineSearch,
        suggestions,
        userLocation,
        isUsingUserLocation,
        useUserLocationError,
        isUserLocationRequested,
        setIsUserLocationRequested,
        isUserLocationLoading,
        clearSearch,
        getStoreDetailsUrl,
        sku,
        events,
        preferredStore, 
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreFinderContext.Provider, {
        value: values
    }, children);
};

const [StoreFinderSlotsProvider, useStoreFinderSlots] = createSlotsContext({
    displayName: 'StoreFinderSlotsContext'
});

const useDistanceUnit = (distance)=>{
    const { distanceUnit  } = useIntl();
    if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
        if (distance && distance < 1000) {
            return DistanceUnit.meter;
        }
    }
    return distanceUnit;
};
/**
 * @param distance
 * @returns returns a string that is the distance including unit and
 * appends "from you" indicator or similar defined on
 * appointments.component.storeFinderItem.distance label
 */ const useFormattedDistance = (distance)=>{
    const { userLocation , isUsingUserLocation  } = useStoreFinderContext();
    const { getFormattedLabel  } = useIntl();
    const distanceUnit = useDistanceUnit(distance);
    const distanceIncludingUnit = distance && formatDistance(distance, distanceUnit, {
        separator: ' '
    });
    if (!distanceIncludingUnit) {
        return undefined;
    }
    return userLocation !== undefined && isUsingUserLocation ? /* show `${distanceIncludingUnit} from you` indication otherwise show just the distance */ getFormattedLabel('appointments.component.storeFinderItem.distance', {
        labelData: {
            distance: distanceIncludingUnit
        }
    }) : distanceIncludingUnit;
};

const StoreInfoWindow = ({ className , code , name , shortName , addressData , email , phone , hideEmail , hidePhone , openingHours , specialOpeningHours , buttons , note , distance , closeInfoWindow , storeDetailsUrl ,  })=>/*#__PURE__*/ React__default.createElement(Location, {
        className: classnames('store-info-window', className),
        id: code,
        name: shortName !== null && shortName !== void 0 ? shortName : name,
        addressData: addressData,
        emailAddress: email,
        emailHidden: hideEmail,
        phone: phone,
        phoneHidden: hidePhone,
        note: note,
        openingHours: openingHours && /*#__PURE__*/ React__default.createElement(OpeningHours, {
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours,
            isExpandable: false
        }),
        buttons: buttons,
        variant: Types.LocationVariant.MapItem,
        formattedDistance: distance,
        closeInfoWindow: closeInfoWindow,
        locationDetailsUrl: storeDetailsUrl
    })
;

const StoreInfoWindowContainer = (_param)=>{
    var { store , buttonsComponent: ButtonsComponent , closeInfoWindow  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "buttonsComponent",
        "closeInfoWindow"
    ]);
    const { config , getStoreDetailsUrl  } = useStoreFinderContext();
    const { hidePhone , hideEmail  } = config;
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province , emailAddress , storeNote ,  } = store;
    const addressData = React__default.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const distance = useFormattedDistance(store === null || store === void 0 ? void 0 : store.distance);
    const storeDetailsUrl = getStoreDetailsUrl(store);
    return /*#__PURE__*/ React__default.createElement(StoreInfoWindow, swcHelpers.extends({}, store, rest, {
        note: /*#__PURE__*/ React__default.createElement(Alert, {
            type: "info",
            icon: "information-circle",
            message: storeNote
        }),
        email: emailAddress || '',
        addressData: addressData,
        hideEmail: hideEmail,
        hidePhone: hidePhone,
        buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
            store: store,
            view: "map",
            closeInfoWindow: closeInfoWindow
        }) : undefined,
        distance: distance,
        storeDetailsUrl: storeDetailsUrl
    }));
};

const currentLocationPin = CurrentLocationPin({
    theme: {
        borderColor: '#2B2E31',
        background: '#fff'
    }
});
const preferredStorePinFallback = PreferredStorePin();
function StoreFinderMapContainer({ stores , infoWindowContentComponent: InfoWindowContentComponent , buttonsComponent: ButtonsComponent  }) {
    const { hoveredStore: hoveredStoreInList , config , isUsingUserLocation , userLocation , isUserLocationRequested , setIsUserLocationRequested , events , preferredStore: preferredStore1 ,  } = useStoreFinderContext();
    const { googleMapsSettings: { preferredStorePin  } ,  } = useGoogleMapsContext();
    const { getLabel  } = useIntl();
    const { googleMapsId , hideEmail , hidePhone  } = config;
    const [activeInfoWindow, setActiveInfoWindow] = React__default.useState(null);
    const [activeStore, setActiveStore] = React__default.useState(null);
    const clickAndReserveMode = useClickAndReserveFeatureConfig();
    const prevStores = Util$1.usePrevious(stores);
    const isPhone = MediaQuery.useIsPhone();
    const [hoveredStore, setHoveredStore] = React__default.useState(null);
    const distance = useFormattedDistance(activeStore === null || activeStore === void 0 ? void 0 : activeStore.distance);
    const handleOnMarkerHover = (code)=>{
        setHoveredStore(code);
    };
    const handleOnClickUseMyLocation = React__default.useCallback(()=>{
        if (!isUserLocationRequested) {
            setIsUserLocationRequested(true);
        }
        if (clickAndReserveMode) {
            var ref;
            events === null || events === void 0 ? void 0 : (ref = events.onClickLocationEvent) === null || ref === void 0 ? void 0 : ref.call(events, clickAndReserveMode, 'map');
        }
    }, [
        isUserLocationRequested,
        events,
        clickAndReserveMode,
        setIsUserLocationRequested
    ]);
    const handleOnMarkerClick = React__default.useCallback((code)=>{
        if (activeInfoWindow === code) {
            setActiveInfoWindow(null);
            setActiveStore(null);
            return;
        }
        // We need to expand the list of stores with a preferredStore if present
        const storesWithPreferredStore = preferredStore1 ? [
            ...stores,
            preferredStore1
        ] : stores;
        const store1 = storesWithPreferredStore.find((store)=>store.code === code
        );
        if (store1) {
            const dataLayerEvent = storesLocatorResultEvent({
                store: store1,
                interaction: 'map click - marker',
                searchResults: stores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
            setActiveInfoWindow(code);
            setActiveStore(store1);
        }
    }, [
        activeInfoWindow,
        preferredStore1,
        stores
    ]);
    const closeInfoWindow = React__default.useCallback(()=>{
        setActiveInfoWindow(null);
        setActiveStore(null);
    }, []);
    const InfoWindowContent = InfoWindowContentComponent !== null && InfoWindowContentComponent !== void 0 ? InfoWindowContentComponent : StoreInfoWindowContainer;
    const preferredStoreMarkerConfig = React__default.useCallback((preferredStore, excludedFromMapBehavior = true)=>{
        const isInactive = !!(preferredStore === null || preferredStore === void 0 ? void 0 : preferredStore.stock) && !hasStock(preferredStore.stock);
        return {
            code: preferredStore.code,
            title: getLabel('stores.component.storeFinderMap.map.pin.title'),
            position: {
                lat: Number(preferredStore.lat),
                lng: Number(preferredStore.lon)
            },
            pin: preferredStorePin || preferredStorePinFallback,
            inactive: isInactive,
            infoWindow: activeInfoWindow === preferredStore.code && !isPhone && /*#__PURE__*/ React__default.createElement(InfoWindow, {
                position: {
                    lat: Number(preferredStore.lat),
                    lng: Number(preferredStore.lon)
                },
                options: {
                    pixelOffset: {
                        width: 0,
                        height: -4
                    }
                },
                onCloseClick: closeInfoWindow
            }, /*#__PURE__*/ React__default.createElement(InfoWindowContent, {
                className: "store-finder-map__info-window-contents",
                store: preferredStore,
                buttonsComponent: ButtonsComponent,
                closeInfoWindow: closeInfoWindow
            })),
            excludedFromMapBehavior
        };
    }, [
        ButtonsComponent,
        InfoWindowContent,
        activeInfoWindow,
        closeInfoWindow,
        getLabel,
        isPhone,
        preferredStorePin, 
    ]);
    const storeMarkers = React__default.useMemo(()=>{
        return stores.map((store)=>{
            const { code , lat , lon  } = store;
            const isInactive = !!(store === null || store === void 0 ? void 0 : store.stock) && !hasStock(store.stock);
            const storeIsPreferredStore = store.code === (preferredStore1 === null || preferredStore1 === void 0 ? void 0 : preferredStore1.code);
            if (storeIsPreferredStore) {
                return preferredStoreMarkerConfig(store, false);
            }
            return {
                code,
                title: getLabel('stores.component.storeFinderMap.map.pin.title'),
                optimized: false,
                position: {
                    lat: Number(lat),
                    lng: Number(lon)
                },
                inactive: isInactive,
                infoWindow: activeInfoWindow === code && !isPhone && /*#__PURE__*/ React__default.createElement(InfoWindow, {
                    position: {
                        lat: Number(lat),
                        lng: Number(lon)
                    },
                    options: {
                        pixelOffset: {
                            width: 0,
                            height: -4
                        }
                    },
                    onCloseClick: closeInfoWindow
                }, /*#__PURE__*/ React__default.createElement(InfoWindowContent, {
                    className: "store-finder-map__info-window-contents",
                    store: store,
                    buttonsComponent: ButtonsComponent,
                    closeInfoWindow: closeInfoWindow
                }))
            };
        });
    }, [
        ButtonsComponent,
        InfoWindowContent,
        activeInfoWindow,
        closeInfoWindow,
        getLabel,
        isPhone,
        preferredStore1 === null || preferredStore1 === void 0 ? void 0 : preferredStore1.code,
        preferredStoreMarkerConfig,
        stores, 
    ]);
    const userLocationMarker = React__default.useMemo(()=>{
        if (isUsingUserLocation && userLocation) {
            return [
                {
                    position: {
                        lat: userLocation.lat,
                        lng: userLocation.lng
                    },
                    pin: currentLocationPin
                }, 
            ];
        }
        return [];
    }, [
        isUsingUserLocation,
        userLocation
    ]);
    const preferredStoreMarker = React__default.useMemo(()=>{
        const preferredStoreFoundInList = !!stores.filter((store)=>{
            return store.code === (preferredStore1 === null || preferredStore1 === void 0 ? void 0 : preferredStore1.code);
        }).length;
        // Only add preferred store marker here if not present in search results
        if (preferredStore1 && !preferredStoreFoundInList) {
            return [
                preferredStoreMarkerConfig(preferredStore1)
            ];
        }
        return [];
    }, [
        preferredStore1,
        preferredStoreMarkerConfig,
        stores
    ]);
    const markers = React__default.useMemo(()=>{
        return [
            ...storeMarkers,
            ...userLocationMarker,
            ...preferredStoreMarker
        ];
    }, [
        preferredStoreMarker,
        storeMarkers,
        userLocationMarker
    ]);
    const center = React__default.useMemo(()=>{
        if (isUsingUserLocation && userLocation !== undefined) {
            return userLocation;
        }
        return undefined;
    }, [
        userLocation,
        isUsingUserLocation
    ]);
    React__default.useEffect(()=>{
        if (prevStores && !isEqualStores(prevStores, stores)) {
            setActiveStore(null);
            setActiveInfoWindow(null);
        }
    }, [
        stores,
        prevStores
    ]);
    var ref1;
    return /*#__PURE__*/ React__default.createElement(LocationSearchMap, {
        id: googleMapsId,
        markers: markers,
        markersUpdateConfig: {
            centerToFirst: true,
            zoom: 13
        },
        center: center,
        highlight: (ref1 = activeStore === null || activeStore === void 0 ? void 0 : activeStore.code) !== null && ref1 !== void 0 ? ref1 : null,
        hovered: hoveredStore !== null && hoveredStore !== void 0 ? hoveredStore : hoveredStoreInList === null || hoveredStoreInList === void 0 ? void 0 : hoveredStoreInList.code,
        userLocation: isUsingUserLocation && userLocation ? userLocation : undefined,
        userLocationZoomLevel: 13,
        centerOnUserLocation: true,
        activeLocation: isPhone && activeStore ? /*#__PURE__*/ React__default.createElement("div", {
            className: "store-finder-map__active-location"
        }, InfoWindowContentComponent && activeStore ? /*#__PURE__*/ React__default.createElement(InfoWindowContentComponent, {
            className: "store-finder-map__active-location-contents",
            store: activeStore,
            buttonsComponent: ButtonsComponent,
            closeInfoWindow: closeInfoWindow
        }) : /*#__PURE__*/ React__default.createElement(Location, {
            className: "store-finder-map__active-location-contents",
            id: activeStore.code,
            name: activeStore.name,
            formattedDistance: distance,
            addressData: {
                additionalStreetInfo: activeStore.additionalStreetInfo,
                streetName: activeStore.streetName,
                streetNumber: activeStore.streetNumber,
                postalCode: activeStore.postalCode,
                town: activeStore.town,
                province: activeStore.province
            },
            emailAddress: activeStore.emailAddress,
            emailHidden: hideEmail,
            phone: activeStore.phone,
            phoneHidden: hidePhone,
            note: /*#__PURE__*/ React__default.createElement(Alert, {
                type: "info",
                icon: "information-circle",
                message: activeStore.storeNote
            }),
            openingHours: /*#__PURE__*/ React__default.createElement(OpeningHours, {
                openingHours: activeStore.openingHours,
                specialOpeningHours: activeStore.specialOpeningHours,
                isExpandable: false
            }),
            buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
                store: activeStore,
                view: "map",
                closeInfoWindow: closeInfoWindow
            }) : undefined,
            variant: Types.LocationVariant.MapItem,
            closeInfoWindow: closeInfoWindow
        })) : null,
        onClickUseMyLocation: handleOnClickUseMyLocation,
        onMarkerClick: handleOnMarkerClick,
        onMarkerHover: handleOnMarkerHover,
        onMapClick: closeInfoWindow
    });
}

const StoreDetailImage = (_param)=> {
    var { className , storeDetailImageUrl , isFallbackImage , width , height , alt  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "storeDetailImageUrl",
        "isFallbackImage",
        "width",
        "height",
        "alt"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames(className, 'store-detail-image-stores-v2', {
            'store-detail-image-stores-v2--fallback': isFallbackImage
        })
    }), /*#__PURE__*/ React__default.createElement("img", {
        className: "store-detail-image-stores-v2__image",
        "data-t": "StoreDetailImage",
        alt: alt,
        src: storeDetailImageUrl,
        width: width,
        height: height
    }));
};

const StoreDetailImageContainer = (_param)=>{
    var { alt , detailImageUrl , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "alt",
        "detailImageUrl",
        "fallbackImage"
    ]);
    const url = detailImageUrl || (fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.url);
    if (!url) {
        return null;
    }
    var ref;
    const altText = !detailImageUrl ? (ref = fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.description) !== null && ref !== void 0 ? ref : alt : alt;
    return /*#__PURE__*/ React__default.createElement(StoreDetailImage, swcHelpers.extends({}, rest, {
        storeDetailImageUrl: url,
        isFallbackImage: !detailImageUrl,
        width: !detailImageUrl ? fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.width : undefined,
        height: !detailImageUrl ? fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.height : undefined,
        alt: altText
    }));
};

const StoreDescription = (_param)=>{
    var { className , labels , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "description"
    ]);
    return description ? /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-description', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), parseHtml(description)) : null;
};

const StoreDescriptionContainer = (_param)=>{
    var { storeName , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeName",
        "description"
    ]);
    const { getFormattedLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getFormattedLabel('stores.page.details.description.title', {
                labelData: {
                    store: storeName
                }
            })
        })
    , [
        storeName,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreDescription, swcHelpers.extends({
        labels: labels,
        description: description
    }, rest));
};

const formatDistanceQueryData = (data, options)=>{
    let { distanceUnit  } = options;
    const { locale  } = options;
    const { distance , timeByCar , timeByFoot  } = data;
    if (distance && distance < 1000) {
        if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
            distanceUnit = DistanceUnit.meter;
        }
    }
    // format the values when they are are not null or undefined
    return {
        distance: distance != undefined ? formatDistance(distance, distanceUnit, {
            separator: ' '
        }) : distance,
        timeByCar: timeByCar != undefined ? DateUtils.minutesToHM(timeByCar, locale) : timeByCar,
        timeByFoot: timeByFoot != undefined ? DateUtils.minutesToHM(timeByFoot, locale) : timeByFoot
    };
};

const storeDistance = gql`
  fragment StoreDistance on Store {
    distance @include(if: $withDistance)
    timeByCar @include(if: $withTimeByCar)
    timeByFoot @include(if: $withTimeByFoot)
  }
`;
const GET_STORE_DISTANCE = gql`
  query GetStoreDistance(
    $code: Int!
    $deviceGeoLocation: GeoLocationInput!
    $withDistance: Boolean = false
    $withTimeByCar: Boolean = false
    $withTimeByFoot: Boolean = false
  ) {
    store(code: $code, deviceGeoLocation: $deviceGeoLocation) {
      ...StoreDistance
    }
  }
  ${storeDistance}
`;

const useStoreDistance = ()=>{
    const [getStoreDistance, { error , loading , data  }] = useLazyQuery(GET_STORE_DISTANCE);
    // @TODO investigate DistanceInMeters type and remove the StoreDistance type cast
    const { distance , timeByCar , timeByFoot  } = (data === null || data === void 0 ? void 0 : data.store) || {};
    return useMemo(()=>[
            getStoreDistance,
            {
                // set a clean attributes list if data is defined and undefined if data is undefined
                data: data ? {
                    distance,
                    timeByCar,
                    timeByFoot
                } : data,
                loading,
                error
            }, 
        ]
    , [
        data,
        distance,
        timeByCar,
        timeByFoot,
        loading,
        error,
        getStoreDistance
    ]);
};

function StoreDistanceContainer({ className , code  }) {
    const { distanceUnit , locale  } = useIntl();
    const [hasPermissions, setHasPermissions] = useState(false);
    const { featureConfigs: { storeDistanceConfig  } = {}  } = useFeatureToggles();
    const { position: deviceLocation , setIsMyLocationRequested  } = useLocation(false, {
        enableHighAccuracy: true,
        maximumAge: 1000
    });
    const [getStoreDistance, { data  }] = useStoreDistance();
    const distanceProps = useMemo(()=>data ? formatDistanceQueryData(data, {
            distanceUnit,
            locale
        }) : {}
    , [
        data,
        distanceUnit,
        locale
    ]);
    useEffect(()=>{
        if (deviceLocation) {
            getStoreDistance({
                variables: {
                    code,
                    deviceGeoLocation: {
                        lat: deviceLocation.lat,
                        lon: deviceLocation.lng
                    },
                    withDistance: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.distance,
                    withTimeByCar: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.timeByCar,
                    withTimeByFoot: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.timeByFoot
                }
            });
        }
    }, [
        code,
        deviceLocation,
        storeDistanceConfig,
        getStoreDistance
    ]);
    useEffect(()=>{
        if (hasPermissions) {
            setIsMyLocationRequested(true);
        } else {
            setIsMyLocationRequested(false);
        }
    }, [
        hasPermissions,
        setIsMyLocationRequested
    ]);
    useEffect(()=>{
        let unsubscribe;
        if ('permissions' in navigator) {
            navigator.permissions.query({
                name: 'geolocation'
            }).then((permissionStatus)=>{
                setHasPermissions(permissionStatus.state === 'granted');
                const handler = ()=>{
                    setHasPermissions(permissionStatus.state === 'granted');
                };
                permissionStatus.addEventListener('change', handler);
                unsubscribe = ()=>permissionStatus.removeEventListener('change', handler)
                ;
            });
        }
        return unsubscribe;
    }, []);
    return /*#__PURE__*/ React__default.createElement(LocationDistance, swcHelpers.extends({
        className: className
    }, distanceProps));
}
var StoreDistance = /*#__PURE__*/ memo(StoreDistanceContainer);

const StoreLocation = (_param)=> {
    var { className , labels , addressSize , addressData , mapImageUrl , directionsUrl , distanceDetails =null , practicalInformation , onGetDirectionsClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "addressSize",
        "addressData",
        "mapImageUrl",
        "directionsUrl",
        "distanceDetails",
        "practicalInformation",
        "onGetDirectionsClick"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-location-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), mapImageUrl && /*#__PURE__*/ React__default.createElement("img", {
        className: "store-location-stores-v2__map",
        src: mapImageUrl,
        alt: labels.title,
        "data-t": "StaticMapImage"
    }), addressData && /*#__PURE__*/ React__default.createElement("span", {
        className: "store-location-stores-v2__subtitle"
    }, labels.address), /*#__PURE__*/ React__default.createElement(Address, {
        size: addressSize,
        data: addressData
    }), distanceDetails && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-location-stores-v2__distance-details"
    }, distanceDetails), practicalInformation && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-location-stores-v2__practical-information"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "store-location-stores-v2__subtitle"
    }, labels.practicalInformationTitle), /*#__PURE__*/ React__default.createElement("p", null, practicalInformation)), directionsUrl && /*#__PURE__*/ React__default.createElement(Button, {
        className: "store-location-stores-v2__get-directions-button",
        hrefTarget: "_blank",
        icon: "location-pin",
        href: directionsUrl,
        onClick: onGetDirectionsClick,
        caption: labels.getDirections,
        variant: "outline"
    }));
};

const StoreLocationContainer = (_param)=>{
    var { opco , code , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , province , lat , lon  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "opco",
        "code",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "province",
        "lat",
        "lon"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.location.title'),
            getDirections: getLabel('stores.page.details.action.getDirections'),
            practicalInformationTitle: getLabel('stores.page.details.practicalInformation.title'),
            address: getLabel('stores.page.details.location.address')
        })
    , [
        getLabel
    ]);
    const addressData = React__default.useMemo(()=>({
            storeName: name,
            streetName,
            streetNumber,
            additionalStreetInfo,
            postalCode,
            town,
            province
        })
    , [
        name,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        town,
        province
    ]);
    const mapImageUrl = useGoogleMapsStaticMap({
        lat,
        lon
    });
    const directionsUrl = getDirectionsUrl({
        streetName,
        town,
        opco
    });
    const onGetDirectionsClick = React__default.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'get directions click',
            store: {
                code,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, [
        code,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreLocation, swcHelpers.extends({}, rest, {
        labels: labels,
        addressSize: "LARGE",
        addressData: addressData,
        mapImageUrl: mapImageUrl,
        directionsUrl: directionsUrl,
        onGetDirectionsClick: onGetDirectionsClick
    }));
};

const StoreBrands = (_param)=> {
    var { className , labels , brands  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "brands"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-brands-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-brands-stores-v2__list"
    }, brands.map(({ name  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: name,
            className: "store-brands-stores-v2__list-item"
        }, name)
    )));
};

const StoreBrandContainer = ({ brands  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.brands.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreBrands, {
        labels: labels,
        brands: brands
    });
};

const StorePaymentMethods = (_param)=> {
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-payment-methods-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-payment-methods-stores-v2__items"
    }, items.map(({ name , iconUrl  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: name,
            className: "store-payment-methods-stores-v2__item"
        }, /*#__PURE__*/ React__default.createElement("img", {
            className: "store-payment-methods-stores-v2__icon",
            alt: name,
            src: iconUrl
        }), name)
    )));
};

const StorePaymentMethodsContainer = (_param)=>{
    var { logos , paymentMethods  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "paymentMethods"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.paymentMethods.title')
        })
    , [
        getLabel
    ]);
    const items = React__default.useMemo(()=>{
        return paymentMethods.map(({ code  })=>{
            var ref;
            const logo = logos === null || logos === void 0 ? void 0 : logos.find(({ key  })=>key === code
            );
            if (!logo) {
                return null;
            }
            return {
                name: logo.displayName,
                iconUrl: (ref = logo.logo) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        paymentMethods,
        logos
    ]);
    return items.length > 0 ? /*#__PURE__*/ React__default.createElement(StorePaymentMethods, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};

const StoreSocialMedia = (_param)=>{
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-social-media-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-social-media-stores-v2__list"
    }, items.map(({ name , url , iconUrl  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: url,
            className: "store-social-media-stores-v2__list-item",
            "data-t": name
        }, /*#__PURE__*/ React__default.createElement("a", {
            href: url,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": name
        }, /*#__PURE__*/ React__default.createElement("img", {
            className: "store-social-media-stores-v2__icon",
            src: iconUrl,
            alt: name
        })))
    )));
};

const StoreSocialMediaContainer = (_param)=>{
    var { logos =[] , socialMediaLinks =[]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "socialMediaLinks"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.socialMedia.title')
        })
    , [
        getLabel
    ]);
    const items = React__default.useMemo(()=>{
        return socialMediaLinks.map(({ code , url  })=>{
            var ref;
            const logo = logos.find(({ image  })=>{
                return (image === null || image === void 0 ? void 0 : image.description) === code;
            });
            if (!logo) {
                return null;
            }
            return {
                name: code,
                url,
                iconUrl: (ref = logo.image) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        logos,
        socialMediaLinks
    ]);
    return items.length > 0 ? /*#__PURE__*/ React__default.createElement(StoreSocialMedia, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};

const openNowFilterFunction = (store)=>{
    const { openingHours , specialOpeningHours  } = store;
    return [
        'OPEN',
        'CLOSING'
    ].includes(getOpenCloseStatus(openingHours, specialOpeningHours));
};
const openOnSundayFilterFunction = (store)=>{
    const { openingHours  } = store;
    const Sunday = 0;
    return [
        'OPEN',
        'CLOSING'
    ].includes(getNormalOpenCloseStatusForDay(openingHours, Sunday));
};
const openOnTheWeekendFilterFunction = (store)=>store.weekendOpen === true
;
const wheelChairAccessibleFilterFunction = (store)=>store.wheelchairAccessible === true
;
const useDefaultStoreSearchFilters = (additionalFilters = {})=>{
    const { getLabel  } = useIntl();
    const storeSearchFilters = React.useMemo(()=>swcHelpers.objectSpread({
            openNow: {
                label: getLabel('stores.component.storeFinder.filter.openNow'),
                active: false,
                filterFunction: openNowFilterFunction,
                order: 0
            },
            openOnTheWeekend: {
                label: getLabel('stores.component.storeFinder.filter.openOnTheWeekend'),
                active: false,
                filterFunction: openOnTheWeekendFilterFunction,
                order: 1
            },
            openOnSunday: {
                label: getLabel('stores.component.storeFinder.filter.openOnSunday'),
                active: false,
                filterFunction: openOnSundayFilterFunction,
                order: 2
            },
            wheelChairAccessible: {
                label: getLabel('stores.component.storeFinder.filter.wheelChairAccessible'),
                active: false,
                filterFunction: wheelChairAccessibleFilterFunction,
                order: 3
            }
        }, additionalFilters)
    , [
        getLabel,
        additionalFilters
    ]);
    return storeSearchFilters;
};
const setLoadingState = (callback)=>{
    callback(true);
    setTimeout(()=>callback(false)
    , 100);
};
const emptyObject = {};
const useStoreSearchFilters = (props)=>{
    const [loading, setLoading] = React.useState(false);
    var _filters1;
    const [storeSearchFilters, setStoreSearchFilters] = React.useState((_filters1 = props.filters) !== null && _filters1 !== void 0 ? _filters1 : emptyObject);
    const storeSearchFilterList = React.useMemo(()=>{
        const entries = Object.entries(storeSearchFilters);
        var _order, _order1;
        return entries.sort(([, a], [, b])=>((_order = a.order) !== null && _order !== void 0 ? _order : entries.length) - ((_order1 = b.order) !== null && _order1 !== void 0 ? _order1 : entries.length)
        ) // Unordered filters come last
        ;
    }, [
        storeSearchFilters
    ]);
    const hasActiveFilters = React.useMemo(()=>storeSearchFilterList.some(([, filter])=>filter.active
        )
    , [
        storeSearchFilterList
    ]);
    const setFilterActivity = React.useCallback((storeFilterName, active)=>{
        setLoadingState(setLoading);
        const filter = storeSearchFilters[storeFilterName];
        setStoreSearchFilters(swcHelpers.objectSpread({}, storeSearchFilters, {
            [storeFilterName]: swcHelpers.objectSpread({}, filter, {
                active
            })
        }));
    }, [
        storeSearchFilters
    ]);
    const activeFilters = React.useMemo(()=>Object.keys(storeSearchFilters).filter((key)=>storeSearchFilters[key].active === true
        )
    , [
        storeSearchFilters
    ]);
    const clearAllFilters = React.useCallback(()=>{
        setLoadingState(setLoading);
        setStoreSearchFilters(Object.keys(storeSearchFilters).reduce((acc, key)=>{
            acc[key] = swcHelpers.objectSpread({}, storeSearchFilters[key], {
                active: false
            });
            return acc;
        }, swcHelpers.objectSpread({}, storeSearchFilters)));
    }, [
        storeSearchFilters
    ]);
    const applyActiveFilters = React.useCallback((storeSearchResults)=>{
        if (!hasActiveFilters) {
            return storeSearchResults;
        }
        return Object.values(storeSearchFilters).reduce((acc, filter)=>{
            if (!filter.active) {
                return acc;
            }
            return acc.filter(filter.filterFunction);
        }, storeSearchResults);
    }, [
        hasActiveFilters,
        storeSearchFilters
    ]);
    React.useEffect(()=>{
        var _filters;
        setStoreSearchFilters((_filters = props.filters) !== null && _filters !== void 0 ? _filters : emptyObject);
    }, [
        props.filters
    ]);
    return React.useMemo(()=>[
            {
                setFilterActivity,
                applyActiveFilters,
                clearAllFilters
            },
            {
                storeSearchFilters,
                storeSearchFilterList,
                hasActiveFilters,
                loading,
                activeFilters
            }, 
        ]
    , [
        setFilterActivity,
        applyActiveFilters,
        clearAllFilters,
        loading,
        storeSearchFilters,
        storeSearchFilterList,
        hasActiveFilters,
        activeFilters, 
    ]);
};

const useTabs = ()=>{
    const { isPristineSearch  } = useStoreFinderContext();
    const isMobile = MediaQuery.useIsPhone();
    return isMobile && !isPristineSearch;
};

const StoreFinderFilterWarning = ({ clearAllFilters , hasActiveFilters , applyActiveFilters ,  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const filteredStores = React.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    if (stores.length === 0) {
        return null;
    }
    if (!hasActiveFilters) {
        return null;
    }
    if (filteredStores.length !== 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        type: "warning",
        icon: "warning"
    }, getLabel('stores.page.search.filters.warning'), /*#__PURE__*/ React.createElement(Button$1, {
        className: "store-finder-stores-v2__clear-filters-action",
        variant: "ghost",
        onClick: clearAllFilters
    }, getLabel('stores.page.search.filters.clearButton')));
};

const StoreListItemContainer = ({ className , store: store1 , buttons , loading , onMouseEnter , onMouseLeave ,  })=>{
    const { config , stores , getStoreDetailsUrl  } = useStoreFinderContext();
    const { hidePhone , hideEmail  } = config;
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province , country  } = store1;
    const addressData = React__default.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province,
            country
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province,
        country
    ]);
    const onMouseEnterHandler = React__default.useCallback(()=>onMouseEnter && onMouseEnter(store1)
    , [
        store1,
        onMouseEnter
    ]);
    const onMouseLeaveHandler = React__default.useCallback(()=>onMouseLeave && onMouseLeave(store1)
    , [
        store1,
        onMouseLeave
    ]);
    const onStoresLocatorResultEvent = React__default.useCallback(({ store , interaction , searchPosition  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onExpandOpeningHoursCallback = React__default.useCallback(()=>{
        onStoresLocatorResultEvent({
            store: store1,
            interaction: 'opening times click',
            searchPosition: stores.indexOf(store1) + 1
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        stores
    ]);
    const distance = useFormattedDistance(store1 === null || store1 === void 0 ? void 0 : store1.distance);
    const storeDetailsUrl = getStoreDetailsUrl(store1);
    return /*#__PURE__*/ React__default.createElement(StoreListItem, {
        className: className,
        onExpandOpeningHoursCallback: onExpandOpeningHoursCallback,
        store: store1,
        addressData: addressData,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        buttons: buttons,
        loading: loading,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        distance: distance,
        storeDetailsUrl: storeDetailsUrl
    });
};

const StoreListTopContentFallback = ()=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(StoreListTopContent, {
        title: getLabel('stores.page.search.title', {
            hideLabelKey: true
        }),
        description: getFormattedLabel('stores.page.search.description', {
            hideLabelKey: true,
            parseLink: true
        })
    });
};

var StoreSearchFilterItemContainer = (_param)=>{
    var { className , filterKey , filter , setFilterActivity  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "filterKey",
        "filter",
        "setFilterActivity"
    ]);
    const { getFormattedLabel  } = useIntl();
    const onClick = React.useCallback(()=>setFilterActivity(filterKey, !filter.active)
    , [
        filterKey,
        filter,
        setFilterActivity
    ]);
    return /*#__PURE__*/ React.createElement(QuickFilterButton, swcHelpers.extends({}, rest, {
        label: filter.label,
        ariaLabels: {
            active: getFormattedLabel(`stores.component.storeFinder.filter.active`, {
                labelData: {
                    filter: filter.label
                }
            }),
            inactive: getFormattedLabel(`stores.component.storeFinder.filter.inactive`, {
                labelData: {
                    filter: filter.label
                }
            })
        },
        active: filter.active,
        onClick: onClick
    }));
};

var StoreSearchFilters = (_param)=>{
    var { className , filters , setFilterActivity  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "filters",
        "setFilterActivity"
    ]);
    const visibleFilters = filters.filter(([, value])=>{
        if (value.hidden === true) {
            return false;
        }
        return true;
    });
    if (!visibleFilters.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('store-search-filters', className)
    }), visibleFilters.map(([filterKey, filter])=>/*#__PURE__*/ React.createElement("li", {
            key: filterKey.toString(),
            className: "store-search-filters__list-item"
        }, /*#__PURE__*/ React.createElement(StoreSearchFilterItemContainer, {
            filterKey: filterKey.toString(),
            filter: filter,
            setFilterActivity: setFilterActivity
        }))
    ));
};

var PlaceByIdFragment = gql`
  fragment PlaceById on Place {
    coordinates {
      lat
      lon
    }
  }
`;

const GET_PLACE_BY_ID = gql`
  query GetPlaceById($id: String!) {
    placeById(id: $id) {
      ...PlaceById
    }
  }
  ${PlaceByIdFragment}
`;

var StoreFragment = gql`
  fragment Store on Store {
    code
    slug
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    name
    shortName
    email
    phone
    storenote
    servicesNotAvailable
    distance
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    wheelchairAccessible
    weekendOpen
  }
`;

var StoreInventoryFragment = gql`
  fragment StoreInventory on Store {
    inventory(sku: $sku) {
      sku
      totalQuantity
      stockIndicator
      items {
        showroomModelAvailable
      }
    }
  }
`;

var StoreOffersFragment = gql`
  fragment StoreOffers on Store {
    offers {
      title
      description
      url
      imageUrl
    }
  }
`;

var StoreReservabilityFragment = gql`
  fragment StoreReservability on Store {
    productReservability {
      inStoreReservable
    }
  }
`;

const GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY = gql`
  query GetStoresByDistance(
    $searchGeoLocation: GeoLocationInput!
    $deviceGeoLocation: GeoLocationInput
    $maxResults: Int
    $query: String
    $filter: StoreFilter
    $forceDistance: Boolean = false
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      deviceGeoLocation: $deviceGeoLocation
      maxResults: $maxResults
      query: $query
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...Store
    }
  }
  ${StoreFragment}
`;
const GET_STORES_BY_DISTANCE_WITH_INVENTORY = gql`
  query GetStoresByDistanceWithInventory(
    $searchGeoLocation: GeoLocationInput!
    $deviceGeoLocation: GeoLocationInput
    $maxResults: Int
    $query: String
    $filter: StoreFilter
    $forceDistance: Boolean = false
    $sku: ID!
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      deviceGeoLocation: $deviceGeoLocation
      maxResults: $maxResults
      query: $query
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...Store
      ...StoreInventory
      ...StoreReservability
      ...StoreOffers
    }
  }
  ${StoreFragment}
  ${StoreInventoryFragment}
  ${StoreReservabilityFragment}
  ${StoreOffersFragment}
`;

var StoreByCodeFragment = gql`
  fragment StoreByCode on Store {
    code
    streetName
    streetNumber
    name
    town
  }
`;

const GET_STORE_BY_CODE = gql`
  query GetStoreByCode($code: Int!) {
    store(code: $code) {
      ...StoreByCode
    }
  }
  ${StoreByCodeFragment}
`;

var StoreDetailsFragment = gql`
  fragment StoreDetails on Store {
    code
    globalStoreId
    slug
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    name
    email
    storeDetailImage
    phone
    description
    storenote
    storeFacilities
    metaDescription
    servicesNotAvailable
    wheelchairAccessible
    practicalInformation
    hearingAppointmentPossible
    features {
      paymentMethods {
        code
      }
      socialMediaLinks {
        code
        url
      }
      availableBrands {
        name
      }
      productCategories {
        code
      }
    }
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    rating {
      value
      count
    }
    breadcrumbName
    breadcrumbSlug
    googlePlaceId
    googlePlaceReviewUrl
  }
`;

const GET_STORE_DETAILS = gql`
  query GetStoreDetails($code: Int, $deviceGeoLocation: GeoLocationInput, $slug: String) {
    store(code: $code, deviceGeoLocation: $deviceGeoLocation, slug: $slug) {
      ...StoreDetails
      ...StoreOffers
    }
  }
  ${StoreDetailsFragment}
  ${StoreOffersFragment}
`;

var NearestStoreFragment = gql`
  fragment NearestStore on Store {
    code
    slug
    town
    shortName
    storeDetailImage
    distance
    breadcrumbName
    breadcrumbSlug
  }
`;

const GET_NEAREST_STORES = gql`
  query GetNearestStores(
    $searchGeoLocation: GeoLocationInput!
    $maxResults: Int
    $maxDistance: Int
    $filter: StoreFilter
    $forceDistance: Boolean
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      maxResults: $maxResults
      maxDistance: $maxDistance
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...NearestStore
    }
  }
  ${NearestStoreFragment}
`;

var StoreAppointmentTypesFragment = gql`
  fragment StoreAppointmentTypes on Store {
    appointmentTypes {
      isAvailableInStore
      id
    }
  }
`;

const GET_PREFERRED_STORE = gql`
  query GetPreferredStore {
    me {
      preferredStore {
        ...Store
        ...StoreAppointmentTypes
      }
    }
  }
  ${StoreFragment}
  ${StoreAppointmentTypesFragment}
`;
const GET_PREFERRED_STORE_WITH_INVENTORY = gql`
  query getPreferredStore($sku: ID!) {
    me {
      preferredStore {
        ...Store
        ...StoreAppointmentTypes
        ...StoreInventory
        ...StoreReservability
      }
    }
  }
  ${StoreFragment}
  ${StoreAppointmentTypesFragment}
  ${StoreInventoryFragment}
  ${StoreReservabilityFragment}
`;

const GET_PREFERRED_STORE_CODE = gql`
  query GetPreferredStoreCode {
    me {
      preferredStore {
        code
      }
    }
  }
`;

const isValidOpeningHoursItem = (entry)=>{
    return !!entry && entry.open !== null && entry.close !== null;
};
const convertToValidOpeningHours = (dayOpeningHours)=>{
    return (dayOpeningHours || []).reduce((collection, item)=>{
        if (isValidOpeningHoursItem(item)) {
            collection.push({
                open: item.open,
                close: item.close
            });
        }
        return collection;
    }, []);
};

const mapStoreResult = (item)=>{
    const inventory = 'inventory' in item ? item.inventory : undefined;
    const productReservability = 'productReservability' in item ? item.productReservability : undefined;
    const appointmentTypes = 'appointmentTypes' in item ? item.appointmentTypes : undefined;
    const storeOffers = 'offers' in item ? item.offers : undefined;
    var _slug, _storenote, _streetNumber, _additionalStreetInfo, _postalCode, _province, _lat, _lon, _email, _servicesNotAvailable, _specialOpenClosingHours, _wheelchairAccessible, _weekendOpen, _totalQuantity, ref;
    return {
        code: item.code,
        name: item.name,
        shortName: item.shortName,
        streetName: item.streetName,
        town: item.town,
        country: item.country,
        phone: item.phone,
        slug: (_slug = item.slug) !== null && _slug !== void 0 ? _slug : undefined,
        storeNote: (_storenote = item.storenote) !== null && _storenote !== void 0 ? _storenote : undefined,
        streetNumber: (_streetNumber = item.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : undefined,
        additionalStreetInfo: (_additionalStreetInfo = item.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : undefined,
        postalCode: (_postalCode = item.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined,
        province: (_province = item.province) !== null && _province !== void 0 ? _province : undefined,
        lat: (_lat = item.lat) !== null && _lat !== void 0 ? _lat : undefined,
        lon: (_lon = item.lon) !== null && _lon !== void 0 ? _lon : undefined,
        emailAddress: (_email = item.email) !== null && _email !== void 0 ? _email : undefined,
        distance: item.distance,
        servicesNotAvailable: (_servicesNotAvailable = item.servicesNotAvailable) !== null && _servicesNotAvailable !== void 0 ? _servicesNotAvailable : [],
        openingHours: {
            monday: convertToValidOpeningHours(item.monOpenClose),
            tuesday: convertToValidOpeningHours(item.tueOpenClose),
            wednesday: convertToValidOpeningHours(item.wedOpenClose),
            thursday: convertToValidOpeningHours(item.thuOpenClose),
            friday: convertToValidOpeningHours(item.friOpenClose),
            saturday: convertToValidOpeningHours(item.satOpenClose),
            sunday: convertToValidOpeningHours(item.sunOpenClose)
        },
        specialOpeningHours: ((_specialOpenClosingHours = item.specialOpenClosingHours) !== null && _specialOpenClosingHours !== void 0 ? _specialOpenClosingHours : []).filter((x)=>x !== null
        ),
        wheelchairAccessible: (_wheelchairAccessible = item.wheelchairAccessible) !== null && _wheelchairAccessible !== void 0 ? _wheelchairAccessible : false,
        weekendOpen: (_weekendOpen = item.weekendOpen) !== null && _weekendOpen !== void 0 ? _weekendOpen : false,
        stock: inventory ? {
            status: inventory.stockIndicator,
            quantity: (_totalQuantity = inventory.totalQuantity) !== null && _totalQuantity !== void 0 ? _totalQuantity : undefined,
            showroomModelAvailable: inventory.items.some((x)=>x.showroomModelAvailable
            )
        } : undefined,
        inStoreReservable: (ref = productReservability === null || productReservability === void 0 ? void 0 : productReservability.inStoreReservable) !== null && ref !== void 0 ? ref : false,
        appointmentTypes: appointmentTypes === null || appointmentTypes === void 0 ? void 0 : appointmentTypes.map((appointmentType)=>({
                id: appointmentType.id,
                isAvailableInStore: appointmentType.isAvailableInStore
            })
        ),
        offers: storeOffers
    };
};
const mapStoresResult = (storeSearchQueryData)=>{
    if (!storeSearchQueryData) {
        return null;
    }
    try {
        return storeSearchQueryData.map(mapStoreResult);
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, storeSearchQueryData);
        return null;
    }
};

const fromPlaceByIdQueryToPlaceById = (data)=>{
    if (!data) {
        return null;
    }
    const { coordinates: { lat , lon  } ,  } = data;
    return {
        coordinates: {
            lat,
            lon
        }
    };
};

const fromStoreByCodeQueryToStoreByCode = (storeQuery)=>{
    if (!storeQuery) {
        return null;
    }
    try {
        const { code , name , streetName , streetNumber , town  } = storeQuery;
        return {
            code,
            name,
            streetName,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            town
        };
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, storeQuery);
        return null;
    }
};

const fromStoreQueryDataToStoreDetails = (storeQueryData)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , globalStoreId , slug , name , description , storenote , email , storeDetailImage , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , metaDescription , servicesNotAvailable , features , storeFacilities , monOpenClose , tueOpenClose , wedOpenClose , thuOpenClose , friOpenClose , satOpenClose , sunOpenClose , specialOpenClosingHours , offers , hearingAppointmentPossible , wheelchairAccessible , breadcrumbName , breadcrumbSlug , practicalInformation , rating , googlePlaceId , googlePlaceReviewUrl ,  } = storeQueryData;
        var ref, ref1, ref2, ref3;
        return {
            code,
            globalStoreId,
            name,
            streetName,
            town,
            country,
            phone,
            practicalInformation: practicalInformation !== null && practicalInformation !== void 0 ? practicalInformation : undefined,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            description: description !== null && description !== void 0 ? description : undefined,
            storeNote: storenote !== null && storenote !== void 0 ? storenote : undefined,
            detailImage: storeDetailImage !== null && storeDetailImage !== void 0 ? storeDetailImage : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            wheelchairAccessible: wheelchairAccessible !== null && wheelchairAccessible !== void 0 ? wheelchairAccessible : undefined,
            hearingAppointmentPossible: hearingAppointmentPossible !== null && hearingAppointmentPossible !== void 0 ? hearingAppointmentPossible : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            metaDescription: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
            servicesNotAvailable: servicesNotAvailable !== null && servicesNotAvailable !== void 0 ? servicesNotAvailable : [],
            breadcrumbName: breadcrumbName !== null && breadcrumbName !== void 0 ? breadcrumbName : undefined,
            breadcrumbSlug: breadcrumbSlug !== null && breadcrumbSlug !== void 0 ? breadcrumbSlug : undefined,
            brands: (ref = features === null || features === void 0 ? void 0 : features.availableBrands) !== null && ref !== void 0 ? ref : [],
            facilities: (storeFacilities !== null && storeFacilities !== void 0 ? storeFacilities : []).filter((entry)=>entry !== null
            ),
            openingHours: {
                monday: convertToValidOpeningHours(monOpenClose),
                tuesday: convertToValidOpeningHours(tueOpenClose),
                wednesday: convertToValidOpeningHours(wedOpenClose),
                thursday: convertToValidOpeningHours(thuOpenClose),
                friday: convertToValidOpeningHours(friOpenClose),
                saturday: convertToValidOpeningHours(satOpenClose),
                sunday: convertToValidOpeningHours(sunOpenClose)
            },
            specialOpeningHours: (specialOpenClosingHours !== null && specialOpenClosingHours !== void 0 ? specialOpenClosingHours : []).filter((entry)=>entry !== null
            ),
            paymentMethods: (ref1 = features === null || features === void 0 ? void 0 : features.paymentMethods) !== null && ref1 !== void 0 ? ref1 : [],
            socialMediaLinks: (ref2 = features === null || features === void 0 ? void 0 : features.socialMediaLinks) !== null && ref2 !== void 0 ? ref2 : undefined,
            storeProductCategories: (ref3 = features === null || features === void 0 ? void 0 : features.productCategories) !== null && ref3 !== void 0 ? ref3 : [],
            offers,
            rating: rating ? {
                value: rating.value,
                count: rating.count
            } : undefined,
            googlePlaceId: googlePlaceId !== null && googlePlaceId !== void 0 ? googlePlaceId : undefined,
            googlePlaceReviewUrl: googlePlaceReviewUrl !== null && googlePlaceReviewUrl !== void 0 ? googlePlaceReviewUrl : undefined
        };
    } catch (e) {
        console.error('Store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

const fromNearestStoresQueryToNearestStores = (nearestStoresQueryData)=>{
    if (!nearestStoresQueryData) {
        return null;
    }
    try {
        return nearestStoresQueryData.map((entry)=>{
            const { code , slug , town , shortName , storeDetailImage , distance , breadcrumbName , breadcrumbSlug ,  } = entry;
            const isDistanceInMeters = (value)=>typeof value === 'number'
            ;
            return {
                code,
                town,
                shortName,
                distance: isDistanceInMeters(distance) ? distance : undefined,
                slug: slug !== null && slug !== void 0 ? slug : undefined,
                detailImage: storeDetailImage !== null && storeDetailImage !== void 0 ? storeDetailImage : undefined,
                groupName: breadcrumbName !== null && breadcrumbName !== void 0 ? breadcrumbName : undefined,
                groupPath: breadcrumbSlug !== null && breadcrumbSlug !== void 0 ? breadcrumbSlug : undefined
            };
        });
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, nearestStoresQueryData);
        return null;
    }
};

const usePlaceById = (variables)=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_BY_ID, {
        variables,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getPlaceById.error');
            console.error('Failed to fetch place by id: ', error);
        }
    });
    return React__default.useMemo(()=>{
        var ref;
        return [
            query,
            swcHelpers.objectSpread({}, queryState, {
                data: fromPlaceByIdQueryToPlaceById((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placeById)
            }), 
        ];
    }, [
        query,
        queryState
    ]);
};

const useStoreByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        onError (error) {
            toast.failed('stores.page.search.getStoreByCode.error');
            console.error('Failed to fetch store by code: ', error);
        }
    });
    var _data;
    const { store  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>fromStoreByCodeQueryToStoreByCode(store)
    , [
        store
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useStoreDetails = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_DETAILS, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = React.useMemo(()=>{
        var ref;
        const storeQueryData = (ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store;
        return fromStoreQueryDataToStoreDetails(storeQueryData);
    }, [
        queryState.data
    ]);
    const getStoreDetails = React.useCallback((slugOrCode)=>{
        query({
            variables: {
                [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
            }
        });
    }, [
        query
    ]);
    React.useEffect(()=>{
        if (queryState.error) {
            console.error('Failed to fetch store details: ', queryState.error);
        }
    }, [
        queryState.error
    ]);
    return React.useMemo(()=>[
            getStoreDetails,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getStoreDetails,
        queryState,
        data
    ]);
};

const useStoresByDistanceWithoutInventory = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getStoresByDistance.error');
            console.error('Failed to fetch store by distance: ', error);
        }
    });
    var _data;
    const { storesByDistance  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>mapStoresResult(storesByDistance)
    , [
        storesByDistance
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useStoresByDistanceWithInventory = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORES_BY_DISTANCE_WITH_INVENTORY, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getStoresByDistance.error');
            console.error('Failed to fetch store by distance: ', error);
        }
    });
    var _data;
    const { storesByDistance  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>mapStoresResult(storesByDistance)
    , [
        storesByDistance
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useGetStoresByDistanceHook = (sku)=>sku ? useStoresByDistanceWithInventory : useStoresByDistanceWithoutInventory
;

const useGetPreferredStore = ({ onError , sku  } = {})=>{
    const query = useQuery(sku ? GET_PREFERRED_STORE_WITH_INVENTORY : GET_PREFERRED_STORE, {
        variables: {
            sku
        },
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreFetch.error');
        }
    });
    const data = React.useMemo(()=>{
        var ref, ref1;
        const storeQueryData = (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.preferredStore;
        if (!storeQueryData) {
            return null;
        }
        return mapStoreResult(storeQueryData);
    }, [
        query.data
    ]);
    return {
        data: data !== null && data !== void 0 ? data : null,
        loading: query.loading,
        error: query.error
    };
};

const useGetPreferredStoreCode = (onError)=>{
    var ref, ref1;
    const query = useQuery(GET_PREFERRED_STORE_CODE, {
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreFetch.error');
        }
    });
    var ref2;
    return {
        data: (ref2 = (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.preferredStore) !== null && ref2 !== void 0 ? ref2 : null,
        loading: query.loading,
        error: query.error
    };
};

const UPDATE_PERSONAL_DETAILS = gql`
  mutation updatePersonalDetails($customerId: ID!, $input: PersonalDetailsB2CUpdateInput!) {
    updateB2CPersonalDetails(customerId: $customerId, input: $input) {
      preferredStore {
        code
      }
    }
  }
`;

const useUpdatePreferredStore = ({ onError , onCompleted  })=>{
    var ref;
    const [mutationCallback, mutation] = useMutation(UPDATE_PERSONAL_DETAILS, {
        onCompleted,
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreUpdate.error');
        }
    });
    var _preferredStore;
    return {
        data: (_preferredStore = mutation === null || mutation === void 0 ? void 0 : (ref = mutation.data) === null || ref === void 0 ? void 0 : ref.updateB2CPersonalDetails.preferredStore) !== null && _preferredStore !== void 0 ? _preferredStore : null,
        loading: mutation === null || mutation === void 0 ? void 0 : mutation.loading,
        error: mutation === null || mutation === void 0 ? void 0 : mutation.error,
        updatePersonalDetails: function() {
            var _ref = swcHelpers.asyncToGenerator(function*(preferredStoreCode, userId) {
                yield mutationCallback({
                    variables: {
                        customerId: userId,
                        input: {
                            preferredStore: preferredStoreCode
                        }
                    }
                });
            });
            return function(preferredStoreCode, userId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};

const useStoreFinderUrlParams = ({ handleOnChange , setIsUserLocation , newQueryParams , enabled =false  })=>{
    const [initialSearchQuery, setInitialSearchQuery] = React__default.useState(undefined);
    React__default.useEffect(()=>{
        if (!enabled) {
            return;
        }
        const search = Util$1.getQueryParamByKey('search');
        const isUserLocation = Util$1.getQueryParamByKey('userLocation') === 'true';
        setIsUserLocation(isUserLocation);
        setInitialSearchQuery(search);
        if ((search === null || search === void 0 ? void 0 : search.length) && !isUserLocation) {
            handleOnChange(search);
        }
    }, [
        enabled
    ]);
    React__default.useEffect(()=>{
        if (enabled) {
            replaceStoreFinderUrlWithNewQueryParams(newQueryParams);
        }
    }, [
        enabled,
        newQueryParams
    ]);
    return initialSearchQuery;
};

const MyCurrentLocation = (_param)=> {
    var { label , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('my-current-location-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Icon, {
        name: "gps"
    }), /*#__PURE__*/ React__default.createElement("span", {
        className: "my-current-location-stores-v2__label"
    }, label));
};

const StoreSearchForm = (_param)=>{
    var { className , labels , loading , showClearButton , searchQuery , suggestions , searchRef , onChange , onSubmit , onClear , onSuggestionClick , onUseMyCurrentLocationClick , isFocusedOnMount , isSuggestionSelected , isUsingUserLocation , minSearchCharacterCount , onSuggestionTopContentClick , queryResultsFilters  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "loading",
        "showClearButton",
        "searchQuery",
        "suggestions",
        "searchRef",
        "onChange",
        "onSubmit",
        "onClear",
        "onSuggestionClick",
        "onUseMyCurrentLocationClick",
        "isFocusedOnMount",
        "isSuggestionSelected",
        "isUsingUserLocation",
        "minSearchCharacterCount",
        "onSuggestionTopContentClick",
        "queryResultsFilters"
    ]);
    const autoCompleteLabels = React__default.useMemo(()=>({
            placeholder: labels.placeholder,
            noResults: labels.noResults,
            noAvailableResultsScreenReaderHint: labels.noAvailableResultsScreenReaderHint
        })
    , [
        labels
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-search-field-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-search-field-stores-v2__search-form"
    }, /*#__PURE__*/ React__default.createElement("form", {
        role: "search",
        action: "",
        onSubmit: (event)=>{
            console.log('Submit was prevented');
            event && event.preventDefault();
            onSubmit();
        }
    }, /*#__PURE__*/ React__default.createElement(Autocomplete, {
        className: classnames({
            'store-search-field-stores-v2__search-form--with-user--location': isUsingUserLocation
        }),
        inputRef: searchRef,
        name: "store-search",
        type: "search",
        labels: autoCompleteLabels,
        isFocusedOnMount: isFocusedOnMount,
        loading: loading,
        value: searchQuery,
        showClearButton: showClearButton,
        submitIcon: /*#__PURE__*/ React__default.createElement(Icon, {
            name: "search"
        }),
        minCountCharactersToSubmit: minSearchCharacterCount,
        isSuggestionSelected: isSuggestionSelected,
        suggestionTopContent: !isUsingUserLocation ? /*#__PURE__*/ React__default.createElement(MyCurrentLocation, {
            label: labels.useMyCurrentLocation
        }) : undefined,
        suggestions: suggestions,
        inputDataT: "search",
        onChange: onChange,
        onSubmit: onSubmit,
        onClear: onClear,
        onSuggestionClick: onSuggestionClick,
        onSuggestionTopContentClick: onSuggestionTopContentClick,
        disabled: isUsingUserLocation
    })), !isUsingUserLocation && /*#__PURE__*/ React__default.createElement(Button, {
        variant: "outline",
        icon: "gps",
        caption: labels.useMyCurrentLocation,
        className: "store-search-field-stores-v2__button",
        onClick: onUseMyCurrentLocationClick,
        "data-t": "userLocationBtn"
    })), queryResultsFilters ? /*#__PURE__*/ React__default.createElement("div", {
        className: "store-search-field-stores-v2__query-results-filters"
    }, queryResultsFilters) : null);
};

const scrollToFormHandlerId = 'location-search-form';
const MIN_SEARCH_CHARACTER_COUNT = 2;
const StoreSearchFormContainer = (_param)=>{
    var { appointmentTypeId , minSearchCharacterCount =MIN_SEARCH_CHARACTER_COUNT , storeQueryFilter , storeQueryForceDistance =true , queryResultsFilters  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointmentTypeId",
        "minSearchCharacterCount",
        "storeQueryFilter",
        "storeQueryForceDistance",
        "queryResultsFilters"
    ]);
    const { getLabel  } = useIntl();
    const { config , searchQuery , isPristineSearch , suggestions , isLocationSelected , userLocation , isUsingUserLocation , isUserLocationLoading , useUserLocationError , setIsUserLocationRequested , clearSearch , setSelectedLocation , setSuggestions , setIsPristineSearch , setStores , setSearchQuery , setIsStoresLoading , sku , events ,  } = useStoreFinderContext();
    const searchRef = /*#__PURE__*/ React__default.createRef();
    const { featureConfigs  } = useFeatureToggles();
    const maxSearchStoresResults = (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.maxSearchStoresResults) !== undefined ? featureConfigs.maxSearchStoresResults : 30;
    const { withUrlParams , storeFilter  } = config;
    const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    const clickAndReserveMode = useClickAndReserveFeatureConfig();
    const [isWaitingForSuggestions, setIsWaitingForSuggestions] = React__default.useState(false);
    const [getPlacePredictions, placePredictions] = usePlacePredictions({
        variables: {
            name: searchQuery
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError: (error)=>{
            toast.failed('stores.page.search.getPlacePredictions.error');
            console.error('Failed to fetch place predictions: ', error);
        }
    });
    const [getPlaceById, placeById] = usePlaceById({
        id: ''
    });
    const useStoresByDistance = useGetStoresByDistanceHook(sku);
    const [getStoresByDistance, storesByDistance] = useStoresByDistance({
        searchGeoLocation: {
            lat: '',
            lon: ''
        },
        filter: storeQueryFilter,
        sku: sku !== null && sku !== void 0 ? sku : '',
        forceDistance: storeQueryForceDistance
    });
    const [userLocationInSessionStorage, setUserLocationInSessionStorage] = useSessionStorage('grandvision_user_location', undefined, (value)=>value === undefined
    );
    const labels = React__default.useMemo(()=>({
            placeholder: getLabel('stores.page.search.searchForm.placeholder'),
            noResults: getLabel('stores.page.autocomplete.noResults'),
            useMyCurrentLocation: getLabel('stores.page.search.useMyCurrentLocation'),
            myCurrentLocationPlaceholder: getLabel('stores.page.search.useMyCurrentLocation.placeholder'),
            noAvailableResultsScreenReaderHint: getLabel('elements.autocomplete.noAvailableResultsScreenReaderHint')
        })
    , [
        getLabel
    ]);
    const onStoreSearchSubmitEvent = React__default.useCallback(({ location , interaction  })=>{
        var ref;
        const dataLayerEvent = storeSearchSubmitEvent({
            interaction,
            location,
            searchResults: ((ref = storesByDistance.data) === null || ref === void 0 ? void 0 : ref.length) || null
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, [
        storesByDistance.data
    ]);
    const handleOnChange = React__default.useCallback((value)=>{
        setSearchQuery(value);
        setIsWaitingForSuggestions(false);
        // In case selected location and value in the search field are the same,
        // nothing changed in the input and we can keep selected location
        setSelectedLocation((prevLocation)=>prevLocation === value ? prevLocation : ''
        );
    }, [
        setSearchQuery,
        setSelectedLocation
    ]);
    /** Hook to build store finder URL based on search state,
   *  to handle initial page state on first page load based on query parameters in URL
   */ const newQueryParams = React__default.useMemo(()=>isUsingUserLocation ? {
            userLocation: 'true'
        } : {
            search: searchQuery
        }
    , [
        isUsingUserLocation,
        searchQuery
    ]);
    const initialSearchQuery = useStoreFinderUrlParams({
        handleOnChange,
        setIsUserLocation: setIsUserLocationRequested,
        newQueryParams,
        enabled: withUrlParams
    });
    const getStoresByLocation = React__default.useCallback((id)=>{
        getPlaceById({
            variables: {
                id
            }
        });
        setIsStoresLoading(true);
        const address = getAddressFromSuggestions(suggestions, id);
        setSelectedLocation(address);
        withUrlParams && replaceStoreFinderUrlWithNewQueryParams({
            search: address
        });
        setSuggestions([]);
        if (isPristineSearch) {
            setIsPristineSearch(false);
        }
    }, [
        getPlaceById,
        setSelectedLocation,
        setSuggestions,
        setIsStoresLoading,
        isPristineSearch,
        suggestions,
        setIsPristineSearch,
        withUrlParams, 
    ]);
    const onSuggestionClick = React__default.useCallback((id)=>{
        getStoresByLocation(id);
    }, [
        getStoresByLocation
    ]);
    const onChange = React__default.useCallback((event)=>handleOnChange(event.currentTarget.value)
    , [
        handleOnChange
    ]);
    const onSubmit = React__default.useCallback(()=>{
        if (suggestions.length > 0) {
            getStoresByLocation(suggestions[0].id);
        } else {
            setIsWaitingForSuggestions(true);
        }
    }, [
        getStoresByLocation,
        setIsWaitingForSuggestions,
        suggestions
    ]);
    React__default.useEffect(()=>{
        if (isUsingUserLocation) {
            setSearchQuery(labels.myCurrentLocationPlaceholder);
            setSelectedLocation(labels.myCurrentLocationPlaceholder);
        }
    }, [
        isUsingUserLocation,
        labels.myCurrentLocationPlaceholder,
        setSearchQuery,
        setSelectedLocation, 
    ]);
    const handleOnSearch = React__default.useCallback(()=>{
        if (searchQuery.length >= minSearchCharacterCount && !isLocationSelected && !isUsingUserLocation) {
            getPlacePredictions({
                variables: {
                    name: searchQuery
                }
            });
        }
    }, [
        searchQuery,
        minSearchCharacterCount,
        isLocationSelected,
        isUsingUserLocation,
        getPlacePredictions, 
    ]);
    const onUseMyCurrentLocation = React__default.useCallback((clickLocation)=>{
        setIsUserLocationRequested(true);
        setIsWaitingForSuggestions(false);
        if (clickAndReserveMode) {
            var ref;
            events === null || events === void 0 ? void 0 : (ref = events.onClickLocationEvent) === null || ref === void 0 ? void 0 : ref.call(events, clickAndReserveMode, clickLocation);
        }
    }, [
        setIsUserLocationRequested,
        setIsWaitingForSuggestions,
        events,
        clickAndReserveMode
    ]);
    useDebouncedEffect(()=>{
        handleOnSearch();
    }, 500, [
        searchQuery
    ]);
    React__default.useEffect(()=>{
        if (!placePredictions.data) {
            return;
        }
        setSuggestions(mapPlacePredictionToSuggestion(placePredictions.data));
    }, [
        placePredictions.data
    ]);
    React__default.useEffect(()=>{
        if (storesByDistance.error || placeById.error) {
            setIsStoresLoading(false);
        }
    }, [
        storesByDistance.error,
        placeById.error,
        setIsStoresLoading
    ]);
    React__default.useEffect(()=>{
        if (useUserLocationError) {
            setSearchQuery('');
            setSelectedLocation('');
            setIsUserLocationRequested(false);
            onStoreSearchSubmitEvent({
                location: null,
                interaction: 'current location'
            });
        }
    }, [
        useUserLocationError,
        setSearchQuery,
        setSelectedLocation,
        setIsUserLocationRequested
    ]);
    React__default.useEffect(()=>{
        if (!placeById.data) {
            return;
        }
        const { coordinates: { lat , lon  } ,  } = placeById.data;
        const deviceGeoLocation = userLocation ? {
            lat: userLocation.lat,
            lon: userLocation.lng
        } : userLocationInSessionStorage && Object.keys(userLocationInSessionStorage).length !== 0 ? {
            lat: userLocationInSessionStorage.lat,
            lon: userLocationInSessionStorage.lng
        } : undefined;
        getStoresByDistance({
            variables: {
                query: appointmentTypeId,
                maxResults: maxSearchStoresResults,
                searchGeoLocation: {
                    lat,
                    lon
                },
                deviceGeoLocation,
                filter: storeQueryFilter,
                forceDistance: storeQueryForceDistance,
                sku: sku !== null && sku !== void 0 ? sku : ''
            }
        });
    // Effect should only run on changing placeById.data or appointmentTypeId
    }, [
        placeById.data,
        appointmentTypeId,
        storeQueryForceDistance,
        sku
    ]);
    React__default.useEffect(()=>{
        var ref;
        if (!storesByDistance.data) {
            return;
        }
        onStoreSearchSubmitEvent({
            location: storesByDistance.data[0].town,
            interaction: isUsingUserLocation && userLocation !== undefined ? 'current location' : 'location typed'
        });
        setStores(storesByDistance.data.filter(storeFilter));
        setIsStoresLoading(false);
        (ref = searchRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        if (isMobile && storesByDistance.data.length > 0) {
            var // Can't use ref in this case because we have two search forms on the page.
            // During the first search ref in useEffect points to the old search field
            // So we need to get needed search form by id.
            // Alternative way ref.current?.scrollIntoView(), but it doesn't work for the first search.
            ref1;
            (ref1 = document.getElementById(scrollToFormHandlerId)) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        storesByDistance.data
    ]);
    React__default.useEffect(()=>{
        if (searchQuery.length < minSearchCharacterCount) {
            setSuggestions([]);
        }
    }, [
        searchQuery,
        minSearchCharacterCount,
        setSuggestions
    ]);
    React__default.useEffect(()=>{
        if (!userLocation) {
            return;
        }
        if (isPristineSearch) {
            setIsPristineSearch(false);
        }
        setUserLocationInSessionStorage(userLocation);
        const { lat , lng: lon  } = userLocation;
        getStoresByDistance({
            variables: {
                query: appointmentTypeId,
                maxResults: maxSearchStoresResults,
                searchGeoLocation: {
                    lat,
                    lon
                },
                deviceGeoLocation: {
                    lat,
                    lon
                },
                forceDistance: storeQueryForceDistance,
                sku: sku !== null && sku !== void 0 ? sku : ''
            }
        });
        setIsStoresLoading(true);
    }, [
        userLocation,
        appointmentTypeId,
        isPristineSearch,
        storeQueryForceDistance,
        sku
    ]);
    /** Should select first suggestion if already waiting for suggestions list */ React__default.useEffect(()=>{
        if (isWaitingForSuggestions && suggestions.length > 0) {
            getStoresByLocation(suggestions[0].id);
            setIsWaitingForSuggestions(false);
        }
    }, [
        suggestions,
        isWaitingForSuggestions,
        getStoresByLocation,
        setIsWaitingForSuggestions
    ]);
    React__default.useEffect(()=>{
        if (initialSearchQuery === searchQuery && isPristineSearch && suggestions.length > 0) {
            getStoresByLocation(suggestions[0].id);
        }
    }, [
        initialSearchQuery,
        searchQuery,
        isPristineSearch,
        suggestions,
        getStoresByLocation
    ]);
    // Dispatch keyup event on Enter and Space manually after pressing key on Use my location from the dropdown.
    // After pressing Use my location from the dropdown input becomes disabled,
    // when input disabled key events don't trigger on it.
    // Need to reset the keypress state to handle cursor correctly.
    React__default.useEffect(()=>{
        var ref, ref2;
        if (!isUsingUserLocation) {
            return;
        }
        (ref = searchRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new KeyboardEvent('keyup', {
            code: 'Enter'
        }));
        (ref2 = searchRef.current) === null || ref2 === void 0 ? void 0 : ref2.dispatchEvent(new KeyboardEvent('keyup', {
            code: 'Space'
        }));
    }, [
        isUsingUserLocation,
        searchRef
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreSearchForm, swcHelpers.extends({}, rest, {
        searchRef: searchRef,
        labels: labels,
        loading: placePredictions.loading || isUserLocationLoading,
        showClearButton: searchQuery.length > 0,
        searchQuery: searchQuery,
        suggestions: suggestions,
        onChange: onChange,
        onSubmit: onSubmit,
        onClear: clearSearch,
        onSuggestionClick: onSuggestionClick,
        onSuggestionTopContentClick: ()=>onUseMyCurrentLocation('search suggestion')
        ,
        onUseMyCurrentLocationClick: ()=>onUseMyCurrentLocation('button')
        ,
        isSuggestionSelected: isLocationSelected,
        isFocusedOnMount: true,
        isUsingUserLocation: isUsingUserLocation,
        minSearchCharacterCount: minSearchCharacterCount,
        queryResultsFilters: queryResultsFilters
    }));
};

const StoreFinderContainer = ({ isInsideModal , listTopContent , listInfoContent , listItemComponent , infoWindowContentComponent , buttonsComponent , storeSearchFilters: propStoreSearchFilters , highlightPreferredStore: HighlightPreferredStore , className ,  })=>{
    const { isStoresLoading , stores , config , setHoveredStore  } = useStoreFinderContext();
    const showTabs = useTabs();
    const { Slots  } = useStoreFinderSlots();
    const [{ setFilterActivity , applyActiveFilters , clearAllFilters  }, { storeSearchFilters , storeSearchFilterList , hasActiveFilters , loading , activeFilters  }, ] = useStoreSearchFilters({
        filters: propStoreSearchFilters
    });
    const { googleMapsId  } = config;
    const prevActiveFilters = React__default.useRef([]);
    const showListTopContent = Boolean(listTopContent);
    const showListInfoContent = Boolean(listInfoContent);
    const ButtonsComponent = buttonsComponent;
    const onMouseEnterHandler = React__default.useCallback((store)=>setHoveredStore(store)
    , [
        setHoveredStore
    ]);
    const onMouseLeaveHandler = React__default.useCallback(()=>setHoveredStore(null)
    , [
        setHoveredStore
    ]);
    const ListItemComponent = listItemComponent !== null && listItemComponent !== void 0 ? listItemComponent : StoreListItemContainer;
    const filteredStores = React__default.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    useEffect(()=>{
        if (prevActiveFilters.current.length !== activeFilters.length) {
            prevActiveFilters.current = activeFilters;
            const dataLayerEvent = storesSearchFilterEvent({
                activeFilters,
                searchResults: filteredStores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        activeFilters
    ]);
    // Add css variable var(--vh) to document
    useAddViewportHeightCssVariable();
    return /*#__PURE__*/ React__default.createElement(LocationSearch, {
        className: classnames('store-finder-stores-v2', className, {
            'store-finder-stores-v2--modal': isInsideModal
        }),
        googleMapsId: googleMapsId,
        showTabs: showTabs,
        searchForm: /*#__PURE__*/ React__default.createElement(StoreSearchFormContainer, {
            queryResultsFilters: (stores === null || stores === void 0 ? void 0 : stores.length) ? /*#__PURE__*/ React__default.createElement(StoreSearchFilters, {
                filters: storeSearchFilterList,
                setFilterActivity: setFilterActivity
            }) : null
        }),
        listTopContent: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, (Slots === null || Slots === void 0 ? void 0 : Slots.SideComponents) ? /*#__PURE__*/ React__default.createElement(Slots.SideComponents, null) : null, showListTopContent ? listTopContent : /*#__PURE__*/ React__default.createElement(StoreListTopContentFallback, null)),
        listInfoContent: showListInfoContent ? listInfoContent : /*#__PURE__*/ React__default.createElement(StoreFinderFilterWarning, {
            applyActiveFilters: applyActiveFilters,
            clearAllFilters: clearAllFilters,
            hasActiveFilters: hasActiveFilters
        }),
        loadingListItems: isStoresLoading,
        listItems: filteredStores.map((store)=>/*#__PURE__*/ React__default.createElement(ListItemComponent, {
                loading: loading,
                key: store.code,
                store: store,
                buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
                    store: store,
                    view: "list"
                }) : undefined,
                onMouseEnter: onMouseEnterHandler,
                onMouseLeave: onMouseLeaveHandler
            })
        ),
        mapContent: /*#__PURE__*/ React__default.createElement(StoreFinderMapContainer, {
            stores: filteredStores,
            infoWindowContentComponent: infoWindowContentComponent,
            buttonsComponent: ButtonsComponent
        }),
        highlightPreferredStore: HighlightPreferredStore
    });
};

const StoreOffersContainer = (props)=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.offers.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, props, {
        labels: labels
    }));
};

const StoreCategoriesContainer = (_param)=>{
    var { storeCategories , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeCategories",
        "fallbackImage"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.productGroups.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, rest, {
        offers: storeCategories,
        fallbackImage: fallbackImage,
        labels: labels
    }));
};

var StoreRatingContainer = (_param)=>{
    var { store  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store"
    ]);
    const { getLabel , getFormattedLabel  } = useIntl();
    const { isStoreRatingsEnabled  } = useFeatureToggles();
    var ref4, ref1;
    const labels = React.useMemo(()=>{
        var ref3, ref2;
        return {
            title: getLabel('stores.component.storeRating.title'),
            rating: getFormattedLabel('stores.component.storeRating.rating', {
                labelData: {
                    rating: (ref4 = (ref3 = store.rating) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref4 !== void 0 ? ref4 : ''
                }
            }),
            ratingCount: getFormattedLabel('stores.component.storeRating.ratingCount', {
                labelData: {
                    count: (ref1 = (ref2 = store.rating) === null || ref2 === void 0 ? void 0 : ref2.count) !== null && ref1 !== void 0 ? ref1 : ''
                }
            }),
            description: getLabel('stores.component.storeRating.description'),
            review: getLabel('stores.component.storeRating.review')
        };
    }, [
        getLabel,
        getFormattedLabel,
        store
    ]);
    const urls = React.useMemo(()=>{
        var ref;
        return {
            review: ((ref = store.googlePlaceReviewUrl) === null || ref === void 0 ? void 0 : ref.length) ? store.googlePlaceReviewUrl : undefined
        };
    }, [
        store
    ]);
    const onClickReview = React.useCallback(()=>{
        // TODO: Implement data layer event
        console.log(store);
    }, [
        store
    ]);
    if (!isStoreRatingsEnabled || !store.rating) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreRating, swcHelpers.extends({}, rest, {
        labels: labels,
        rating: store.rating.value,
        urls: urls,
        onClickReview: onClickReview
    }));
};

const PreferredStoreTile = ({ className , store , loading =false , buttonsComponent: ButtonsComponent ,  })=>/*#__PURE__*/ React.createElement(StoreListItemContainer, {
        className: classnames('stores-v2-preferred-store-tile', className),
        store: store,
        loading: loading,
        buttons: /*#__PURE__*/ React.createElement(ButtonsComponent, {
            store: store,
            view: "list"
        })
    })
;

const useIsInViewport = (currentElement)=>{
    const [isInViewport, setIsInViewport] = React.useState(false);
    const checkIsInViewport = ()=>{
        if (!currentElement.current) {
            setIsInViewport(false);
            return;
        }
        const { top , height: refHeight  } = currentElement.current.getBoundingClientRect();
        setIsInViewport(top + refHeight >= 0 && top <= window.innerHeight);
    };
    React.useEffect(()=>{
        checkIsInViewport();
        const throttledCheckIsInViewport = throttle(200, false, ()=>{
            checkIsInViewport();
        });
        window.addEventListener('scroll', throttledCheckIsInViewport);
        return ()=>window.removeEventListener('scroll', throttledCheckIsInViewport)
        ;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (typeof window === 'undefined') {
        return false;
    }
    return isInViewport;
};

const usePreferredStore = (storeName)=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const [preferredStoreState, setPreferredStoreState] = React.useState(null);
    const { preferredStoreSuccess , preferredStoreUpdated , preferredStoreLabel  } = preferredStoreState !== null && preferredStoreState !== void 0 ? preferredStoreState : {};
    const preferredStoreAlertLabel = preferredStoreSuccess ? getFormattedLabel(preferredStoreLabel !== null && preferredStoreLabel !== void 0 ? preferredStoreLabel : '', {
        labelData: {
            storeName
        },
        parseLink: true
    }) : getLabel(preferredStoreLabel !== null && preferredStoreLabel !== void 0 ? preferredStoreLabel : '');
    const onHandlePreferredStoreChange = (updated, success, label)=>{
        setPreferredStoreState({
            preferredStoreUpdated: updated,
            preferredStoreSuccess: success,
            preferredStoreLabel: label
        });
    };
    return {
        preferredStoreAlertLabel,
        preferredStoreUpdated,
        preferredStoreSuccess,
        onHandlePreferredStoreChange
    };
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useIsInViewport: useIsInViewport,
  useDefaultStoreSearchFilters: useDefaultStoreSearchFilters,
  useStoreSearchFilters: useStoreSearchFilters,
  useFormattedDistance: useFormattedDistance,
  useTabs: useTabs,
  usePreferredStore: usePreferredStore,
  usePlaceById: usePlaceById,
  useStoreByCode: useStoreByCode,
  useStoreDetails: useStoreDetails,
  useStoresByDistanceWithoutInventory: useStoresByDistanceWithoutInventory,
  useStoresByDistanceWithInventory: useStoresByDistanceWithInventory,
  useGetStoresByDistanceHook: useGetStoresByDistanceHook,
  useGetPreferredStore: useGetPreferredStore,
  useGetPreferredStoreCode: useGetPreferredStoreCode,
  useUpdatePreferredStore: useUpdatePreferredStore
});

const HighlightPreferredStoreContainer = ({ buttonsComponent: ButtonsComponent  })=>{
    const { getLabel  } = useIntl();
    const { setPreferredStore  } = useStoreFinderContext();
    const { data: store  } = useGetPreferredStore();
    const title = getLabel('stores.component.storeFinder.preferredStoreTile.title');
    React.useEffect(()=>{
        if (store) {
            setPreferredStore(store);
        }
    }, [
        store,
        setPreferredStore
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(HighlightPrefferedStore, {
        title: title
    }, /*#__PURE__*/ React.createElement(PreferredStoreTile, {
        store: store,
        buttonsComponent: ButtonsComponent
    }));
};
var HighlightPreferredStoreContainer$1 = ((props)=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(HighlightPreferredStoreContainer, swcHelpers.extends({}, props)))
);

const PreferredStoreButtonContainer = ({ storeCode , storeName  })=>{
    const { getLabel  } = useIntl();
    const userId = useSelector(Selectors.getUserId);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const { onHandlePreferredStoreChange  } = usePreferredStore(storeName);
    const { updatePersonalDetails , data: mutatedData , loading: isUpdating ,  } = useUpdatePreferredStore({
        onCompleted: ()=>onHandlePreferredStoreChange(isUpdating, true, 'stores.storeDetailsRoot.preferredStoreUpdate.success')
        ,
        onError: (_, label)=>{
            onHandlePreferredStoreChange(isUpdating, false, label);
        }
    });
    const { data , loading  } = useGetPreferredStoreCode();
    if (loading || !userId || !isLoggedIn) {
        return null;
    }
    const { code: preferredStoreCode  } = data !== null && data !== void 0 ? data : {};
    const isPreferredStore = storeCode === preferredStoreCode || storeCode === (mutatedData === null || mutatedData === void 0 ? void 0 : mutatedData.code);
    const onClick = ()=>updatePersonalDetails(storeCode.toString(), userId)
    ;
    return /*#__PURE__*/ React.createElement(PreferredStoreButton, {
        labels: {
            preferredStore: getLabel('stores.preferredStoreButton.active'),
            setPreferredStore: getLabel('stores.preferredStoreButton.set')
        },
        onClick: onClick,
        selected: isPreferredStore
    });
};
var PreferredStoreButtonContainer$1 = ((props)=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(PreferredStoreButtonContainer, swcHelpers.extends({}, props)))
);

const DefaultButtonsContainer = ({ store: store1 , view , storeDetailsUrlProvider , bookAppointmentUrlProvider ,  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const storeDetailsUrl = storeDetailsUrlProvider(store1);
    const bookAppointmentUrl = bookAppointmentUrlProvider(store1);
    const showBookAppointmentCTA = areServicesAvailable(store1, [
        Types$1.ServicesNotAvailable.APPOINTMENTS, 
    ]);
    const { code  } = store1;
    const onStoresLocatorResultEvent = React__default.useCallback(({ store , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onBookAppointmentButtonClickHandler = React__default.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'book appointment click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - book appointment',
            searchResults: stores.length
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores
    ]);
    const onStoreDetailButtonClickHandler = React__default.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'store details click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - store details',
            searchResults: stores.length
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores
    ]);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showBookAppointmentCTA ? /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onBookAppointmentButtonClickHandler,
        href: bookAppointmentUrl,
        variant: "solid",
        size: "small",
        "data-t": `book-appointment-${code}`,
        caption: getLabel('stores.page.storeGroup.action.bookAppointment')
    }) : null, /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onStoreDetailButtonClickHandler,
        href: storeDetailsUrl,
        variant: "outline",
        size: "small",
        "data-t": `store-details-${code}`,
        caption: getLabel('stores.page.storeGroup.action.storeDetails')
    }));
};
function withDefaultButtonsConfig(buttonsComponent, config) {
    const ButtonsComponent = buttonsComponent;
    const WithDefaultButtonsConfig = (props)=>{
        const { featureConfigs: { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } ,  } = useFeatureToggles();
        const { urls  } = config;
        if (!urls.storeDetails) {
            console.error(`Missing url for storeDetails within withDefaultButtonsConfig`);
        }
        const storeDetailsUrlProvider = getStoreDetailUrl(urls.storeDetails || '');
        if (!urls.bookAppointment) {
            console.error(`Missing url for bookAppointment within withDefaultButtonsConfig`);
        }
        const bookAppointmentUrlProvider = getBookAppointmentUrl(urls.bookAppointment || '', {
            paddedLength: appointmentBookingUrlPaddedLength,
            alternativeUrl: appointmentBookingAlternativeUrl,
            alternativeUrlStores: appointmentBookingAlternativeUrlStores
        });
        return /*#__PURE__*/ React__default.createElement(ButtonsComponent, swcHelpers.extends({}, props, {
            storeDetailsUrlProvider: storeDetailsUrlProvider,
            bookAppointmentUrlProvider: bookAppointmentUrlProvider
        }));
    };
    WithDefaultButtonsConfig.displayName = `WithDefaultButtonsConfig${getDisplayName(ButtonsComponent)}`;
    return WithDefaultButtonsConfig;
}

const PickUpButtonsContainer = ({ store: store1 , view , onStoreSelect  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const onStoresLocatorResultEvent = React__default.useCallback(({ store , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onClick = React__default.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'select store click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - select store',
            searchResults: stores.length
        });
        onStoreSelect(store1);
    }, [
        onStoresLocatorResultEvent,
        onStoreSelect,
        store1,
        view,
        stores
    ]);
    return /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onClick,
        variant: "outline",
        size: "small",
        "data-t": `select-pick-up-store-${store1.code}`,
        caption: getLabel('checkout.storeFinder.action')
    });
};
function withPickUpButtonsConfig(buttonsComponent, config) {
    const ButtonsComponent = buttonsComponent;
    const WithPickUpButtonsConfig = (props)=>{
        const { onStoreSelect  } = config;
        return /*#__PURE__*/ React__default.createElement(ButtonsComponent, swcHelpers.extends({}, props, {
            onStoreSelect: onStoreSelect
        }));
    };
    WithPickUpButtonsConfig.displayName = `WithPickUpButtonsConfig${getDisplayName(ButtonsComponent)}`;
    return WithPickUpButtonsConfig;
}

const NearbyStores = ({ id ='nearby-stores' , className , labels , stores , links ,  })=>/*#__PURE__*/ React.createElement("section", {
        id: id,
        className: classnames('nearby-stores', className),
        "aria-labelledby": `${id}-title`
    }, /*#__PURE__*/ React.createElement(Heading, {
        id: `${id}-title`,
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React.createElement("div", {
        className: "nearby-stores__group"
    }, stores.map(({ code , url , image , label , distance  })=>/*#__PURE__*/ React.createElement("a", {
            className: "nearby-stores__group-item",
            key: code,
            href: url
        }, /*#__PURE__*/ React.createElement("img", {
            className: "nearby-stores__group-item-thumbnail",
            loading: "lazy",
            src: image,
            alt: label
        }), /*#__PURE__*/ React.createElement(Text, {
            className: "nearby-stores__group-item-label",
            variant: "body-head"
        }, label), /*#__PURE__*/ React.createElement(Text, {
            className: "nearby-stores__group-item-distance",
            variant: "body"
        }, distance))
    )), /*#__PURE__*/ React.createElement("div", {
        className: "nearby-stores__links"
    }, links.map(({ label , url  })=>/*#__PURE__*/ React.createElement("a", {
            key: url,
            href: url
        }, label)
    )))
;

var NearbyStoresContainer = (_param)=>{
    var { stores: storeData , urls , storeDetails  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "stores",
        "urls",
        "storeDetails"
    ]);
    const { getLabel , distanceUnit , getFormattedLabel  } = useIntl();
    const storeDetailsUrlProvider = React.useMemo(()=>{
        return getStoreDetailUrl((urls === null || urls === void 0 ? void 0 : urls.storeDetails) || '');
    }, [
        urls
    ]);
    const labels = React.useMemo(()=>({
            title: getLabel('stores.component.nearbyStores.title')
        })
    , [
        getLabel
    ]);
    const stores = React.useMemo(()=>{
        return storeData.filter((store)=>{
            return !(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.code) || (storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.code) !== store.code;
        }).map((store)=>{
            const storeDetailsUrl = storeDetailsUrlProvider(store);
            const distance = store.distance !== undefined ? formatDistance(store.distance, distanceUnit, {
                separator: ' '
            }) : store.distance;
            var _detailImage, ref;
            return {
                code: store.code,
                url: storeDetailsUrl,
                image: (ref = (_detailImage = store.detailImage) !== null && _detailImage !== void 0 ? _detailImage : urls === null || urls === void 0 ? void 0 : urls.fallbackImage) !== null && ref !== void 0 ? ref : '',
                label: store.shortName,
                distance: getFormattedLabel('stores.component.nearbyStores.distance', {
                    labelData: {
                        distance: distance !== null && distance !== void 0 ? distance : ''
                    }
                })
            };
        });
    }, [
        storeData,
        urls,
        distanceUnit,
        storeDetailsUrlProvider,
        getFormattedLabel,
        storeDetails
    ]);
    const links = React.useMemo(()=>{
        const linksToBeAdded = [];
        if ((storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.breadcrumbName) && (storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.breadcrumbSlug)) {
            linksToBeAdded.push({
                label: getFormattedLabel('stores.component.nearbyStores.group', {
                    labelData: {
                        groupName: storeDetails.breadcrumbName
                    }
                }),
                url: storeDetails.breadcrumbSlug
            });
        }
        if (urls === null || urls === void 0 ? void 0 : urls.storeOverview) {
            linksToBeAdded.push({
                label: getLabel('stores.component.nearbyStores.allStores'),
                url: urls.storeOverview
            });
        }
        return linksToBeAdded;
    }, [
        urls,
        getLabel,
        getFormattedLabel,
        storeDetails
    ]);
    return /*#__PURE__*/ React.createElement(NearbyStores, swcHelpers.extends({}, rest, {
        labels: labels,
        stores: stores,
        links: links
    }));
};

var containers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  StoreBookAppointmentCTA: StoreBookAppointmentCTAContainer,
  StoreFacilities: StoreFacilitiesContainer,
  StoreFinderMap: StoreFinderMapContainer,
  StoreDetailImage: StoreDetailImageContainer,
  StoreDescription: StoreDescriptionContainer,
  StoreDistance: StoreDistance,
  StoreLocation: StoreLocationContainer,
  StoreBrands: StoreBrandContainer,
  StorePaymentMethods: StorePaymentMethodsContainer,
  StoreSocialMedia: StoreSocialMediaContainer,
  StoreFinder: StoreFinderContainer,
  StoreSearchForm: StoreSearchFormContainer,
  StoreListItem: StoreListItemContainer,
  StoreOffers: StoreOffersContainer,
  StoreCategories: StoreCategoriesContainer,
  StoreRating: StoreRatingContainer,
  PreferredStoreTile: PreferredStoreTile,
  HighlightPreferredStore: HighlightPreferredStoreContainer$1,
  PreferredStoreButton: PreferredStoreButtonContainer$1,
  DefaultButtons: DefaultButtonsContainer,
  withDefaultButtonsConfig: withDefaultButtonsConfig,
  PickUpButtons: PickUpButtonsContainer,
  withPickUpButtonsConfig: withPickUpButtonsConfig,
  NearbyStores: NearbyStoresContainer
});

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Actions: actions,
  Types: types$1
});

const OPENING_HOURS_DAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday', 
];
var OpenClosedStatus;
(function(OpenClosedStatus) {
    OpenClosedStatus["Open"] = 'OPEN';
    OpenClosedStatus["Closing"] = 'CLOSING';
    OpenClosedStatus["Closed"] = 'CLOSED';
})(OpenClosedStatus || (OpenClosedStatus = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  OPENING_HOURS_DAYS: OPENING_HOURS_DAYS,
  get OpenClosedStatus () { return OpenClosedStatus; }
});

function getPageData$1(apolloClient, slugOrCode, locale) {
    return _getPageData$1.apply(this, arguments);
}
function _getPageData$1() {
    _getPageData$1 = swcHelpers.asyncToGenerator(function*(apolloClient, slugOrCode, locale, withNearestStores = false, maxDistance) {
        try {
            var ref;
            const storeQuery = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_STORE_DETAILS,
                variables: {
                    [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeQueryData = (ref = storeQuery.data) === null || ref === void 0 ? void 0 : ref.store;
            const storeData = fromStoreQueryDataToStoreDetails(storeQueryData);
            if (storeQuery.error) {
                console.error(storeQuery.error);
            }
            const nearestStores = [];
            if (withNearestStores && (storeData === null || storeData === void 0 ? void 0 : storeData.lat) !== undefined && (storeData === null || storeData === void 0 ? void 0 : storeData.lon) !== undefined) {
                var ref1;
                const nearestStoresQuery = yield apolloClient.query({
                    query: GET_NEAREST_STORES,
                    variables: {
                        searchGeoLocation: {
                            lat: storeData === null || storeData === void 0 ? void 0 : storeData.lat,
                            lon: storeData === null || storeData === void 0 ? void 0 : storeData.lon
                        },
                        forceDistance: true,
                        maxResults: 2,
                        maxDistance,
                        filter: {
                            excludeGlobalStoreId: `${storeData === null || storeData === void 0 ? void 0 : storeData.globalStoreId}`
                        }
                    }
                });
                const nearestStoresQueryData = (ref1 = nearestStoresQuery.data) === null || ref1 === void 0 ? void 0 : ref1.storesByDistance;
                var ref2;
                nearestStores.push(...(ref2 = fromNearestStoresQueryToNearestStores(nearestStoresQueryData)) !== null && ref2 !== void 0 ? ref2 : []);
                if (nearestStoresQuery.error) {
                    console.error(nearestStoresQuery.error);
                }
            }
            return {
                storeData,
                nearestStores
            };
        } catch (e) {
            console.error(e);
            return {
                storeData: null,
                nearestStores: []
            };
        }
    });
    return _getPageData$1.apply(this, arguments);
}

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPageData: getPageData$1
});

const fromListStoreGroupsQueryToStoreGroup = (data)=>{
    if (!data) {
        return {};
    }
    const sortedStores = [
        ...data.multiStoreGroups,
        ...data.singleStoreGroups
    ].sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    const storeGroups = sortedStores.reduce((acc, value)=>{
        const firstNameStoreLetter = value.name.toUpperCase()[0];
        const existingStore = acc[firstNameStoreLetter];
        const groupedExistingStores = existingStore && [
            ...existingStore,
            value
        ];
        return swcHelpers.objectSpread({}, acc, {
            [firstNameStoreLetter]: groupedExistingStores ? groupedExistingStores : [
                value
            ]
        });
    }, {});
    return storeGroups;
};

const listStoreGroups$1 = gql`
  fragment ListStoreGroups on StoreGroups {
    singleStoreGroups {
      name
      store {
        slug
        town
      }
    }
    multiStoreGroups {
      name
      slug
    }
  }
`;
const GET_LIST_STORE_GROUPS$1 = gql`
  query GetListStoreGroups {
    listStoreGroups {
      ...ListStoreGroups
    }
  }
  ${listStoreGroups$1}
`;

function getListStoreGroups(apolloClient, locale) {
    return _getListStoreGroups.apply(this, arguments);
}
function _getListStoreGroups() {
    _getListStoreGroups = swcHelpers.asyncToGenerator(function*(apolloClient, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_LIST_STORE_GROUPS$1
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return fromListStoreGroupsQueryToStoreGroup(data === null || data === void 0 ? void 0 : data.listStoreGroups);
        } catch (e) {
            console.error(`Failed to query listStoreGroups: ${e}`);
            return {};
        }
    });
    return _getListStoreGroups.apply(this, arguments);
}

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fromListStoreGroupsQueryToStoreGroup: fromListStoreGroupsQueryToStoreGroup,
  getListStoreGroups: getListStoreGroups,
  GET_LIST_STORE_GROUPS: GET_LIST_STORE_GROUPS$1
});

function getStores(apolloClient, _) {
    return _getStores.apply(this, arguments);
}
function _getStores() {
    _getStores = swcHelpers.asyncToGenerator(function*(apolloClient, { coordinates: { lat , lon  } , locale , maxResults =30 , forceDistance  }) {
        const variables = {
            searchGeoLocation: {
                lat,
                lon
            },
            maxResults,
            forceDistance
        };
        try {
            const { data , error  } = yield apolloClient.query({
                query: GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY,
                variables,
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            });
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return mapStoresResult(data.storesByDistance);
        } catch (e) {
            console.error(`Failed to query stores: ${e}`);
            return [];
        }
    });
    return _getStores.apply(this, arguments);
}

const listStoreGroups = gql`
  fragment ListStoreGroups on StoreGroups {
    singleStoreGroups {
      name
      store {
        slug
        town
      }
    }
    multiStoreGroups {
      name
      slug
    }
  }
`;
const GET_LIST_STORE_GROUPS = gql`
  query GetListStoreGroups {
    listStoreGroups {
      ...ListStoreGroups
    }
  }
  ${listStoreGroups}
`;

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getStores: getStores,
  GET_LIST_STORE_GROUPS: GET_LIST_STORE_GROUPS
});

const getRating = (rating)=>{
    const features = EnvironmentUtils.getFeatures();
    if (!features.includes('STORE_RATINGS_STORE_GROUP')) {
        return;
    }
    if ((rating === null || rating === void 0 ? void 0 : rating.value) === undefined) {
        return;
    }
    return {
        value: rating.value,
        count: rating.count
    };
};

const fromStoreGroupQueryDataToStores = (storeGroupQueryData)=>{
    if (!storeGroupQueryData) {
        return null;
    }
    try {
        return storeGroupQueryData.map(fromStoreGroupEntryToStore);
    } catch (e) {
        console.error('Store group query data adapter failed to parse input data correctly.', e, storeGroupQueryData);
        return null;
    }
};
const fromStoreGroupEntryToStore = (entry1)=>{
    var _rating, _slug, _storenote, _streetNumber, _additionalStreetInfo, _postalCode, _province, _lat, _lon, _email, _servicesNotAvailable, _specialOpenClosingHours, _storeDetailImage, _wheelchairAccessible, _weekendOpen;
    return {
        code: entry1.code,
        name: entry1.name,
        shortName: entry1.name,
        streetName: entry1.streetName,
        town: entry1.town,
        country: entry1.country,
        rating: getRating((_rating = entry1.rating) !== null && _rating !== void 0 ? _rating : undefined),
        phone: entry1.phone,
        slug: (_slug = entry1.slug) !== null && _slug !== void 0 ? _slug : undefined,
        storeNote: (_storenote = entry1.storenote) !== null && _storenote !== void 0 ? _storenote : undefined,
        streetNumber: (_streetNumber = entry1.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : undefined,
        additionalStreetInfo: (_additionalStreetInfo = entry1.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : undefined,
        postalCode: (_postalCode = entry1.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined,
        province: (_province = entry1.province) !== null && _province !== void 0 ? _province : undefined,
        lat: (_lat = entry1.lat) !== null && _lat !== void 0 ? _lat : undefined,
        lon: (_lon = entry1.lon) !== null && _lon !== void 0 ? _lon : undefined,
        emailAddress: (_email = entry1.email) !== null && _email !== void 0 ? _email : undefined,
        servicesNotAvailable: (_servicesNotAvailable = entry1.servicesNotAvailable) !== null && _servicesNotAvailable !== void 0 ? _servicesNotAvailable : [],
        openingHours: {
            monday: convertToValidOpeningHours(entry1.monOpenClose),
            tuesday: convertToValidOpeningHours(entry1.tueOpenClose),
            wednesday: convertToValidOpeningHours(entry1.wedOpenClose),
            thursday: convertToValidOpeningHours(entry1.thuOpenClose),
            friday: convertToValidOpeningHours(entry1.friOpenClose),
            saturday: convertToValidOpeningHours(entry1.satOpenClose),
            sunday: convertToValidOpeningHours(entry1.sunOpenClose)
        },
        specialOpeningHours: ((_specialOpenClosingHours = entry1.specialOpenClosingHours) !== null && _specialOpenClosingHours !== void 0 ? _specialOpenClosingHours : []).filter((entry)=>entry !== null
        ),
        storeDetailImage: (_storeDetailImage = entry1.storeDetailImage) !== null && _storeDetailImage !== void 0 ? _storeDetailImage : undefined,
        wheelchairAccessible: (_wheelchairAccessible = entry1.wheelchairAccessible) !== null && _wheelchairAccessible !== void 0 ? _wheelchairAccessible : false,
        weekendOpen: (_weekendOpen = entry1.weekendOpen) !== null && _weekendOpen !== void 0 ? _weekendOpen : false
    };
};

const storeGroupEntry = gql`
  fragment StoreGroupEntry on Store {
    code
    name
    streetName
    streetNumber
    additionalStreetInfo
    town
    province
    country
    slug
    rating {
      value
      count
    }
    postalCode
    storeEmailAddress
    email
    phone
    servicesNotAvailable
    lat
    lon
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    weekendOpen
    storenote
    storeDetailImage
    wheelchairAccessible
  }
`;
const GET_STORE_GROUP = gql`
  query GetStoreGroup($groupName: String!) {
    stores(groupName: $groupName) {
      ...StoreGroupEntry
    }
  }
  ${storeGroupEntry}
`;

function getPageData(apolloClient, groupName, locale) {
    return _getPageData.apply(this, arguments);
}
function _getPageData() {
    _getPageData = swcHelpers.asyncToGenerator(function*(apolloClient, groupName, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_STORE_GROUP,
                variables: {
                    groupName
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeGroupQueryData = data.stores;
            const stores = fromStoreGroupQueryDataToStores(storeGroupQueryData);
            if (error) {
                console.error(error);
            }
            if (!stores) {
                return null;
            }
            return {
                stores
            };
        } catch (e) {
            console.error(e);
            return null;
        }
    });
    return _getPageData.apply(this, arguments);
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPageData: getPageData
});

const StoreDetailsRoot = ({ store , opco , hidePhone , hideEmail , breadcrumbs , urls , appointmentTypeId , logos , dropInAppointmentBookingWidget: DropInWidget = null , nearestStores =[] , campaignBanner , productCategories , preferredStoreButton ,  })=>{
    var ref;
    const { getFormattedLabel  } = useIntl();
    const canShowBookAppointmentWidget = areServicesAvailable(store, [
        Types$1.ServicesNotAvailable.APPOINTMENTS
    ]) && Boolean((ref = urls.bookAppointment) === null || ref === void 0 ? void 0 : ref.length);
    const showBookAppointmentDropInWidget = canShowBookAppointmentWidget && Boolean(appointmentTypeId === null || appointmentTypeId === void 0 ? void 0 : appointmentTypeId.length) && DropInWidget;
    const showBookAppointmentCTA = canShowBookAppointmentWidget && !showBookAppointmentDropInWidget;
    const { name , shortName , description , detailImage , emailAddress , phone , streetName , streetNumber , postalCode , town , province , country , code , additionalStreetInfo , lat , lon , storeNote , openingHours , specialOpeningHours , facilities , brands , paymentMethods , socialMediaLinks , offers , wheelchairAccessible , storeProductCategories , hearingAppointmentPossible ,  } = store;
    const bookAppointmentButtonRef = React.useRef(null);
    const dropInWidgetRef = React.useRef(null);
    const isBookAppointmentButtonInViewport = useIsInViewport(bookAppointmentButtonRef);
    const isDropInWidgetInViewport = useIsInViewport(dropInWidgetRef);
    const storeCategories = getActiveStoreOffers(productCategories, storeProductCategories);
    const activeCampaignBanner = getActiveCampaignBanner(campaignBanner, {
        storeCode: code
    });
    const { preferredStoreUpdated , preferredStoreSuccess , preferredStoreAlertLabel  } = usePreferredStore(shortName !== null && shortName !== void 0 ? shortName : name);
    const { featureConfigs: { storeDistanceConfig  } = {}  } = useFeatureToggles();
    const hideStickyBookAppointmentButton = isBookAppointmentButtonInViewport || isDropInWidgetInViewport;
    const showPaymentMethods = !!paymentMethods && !!(logos === null || logos === void 0 ? void 0 : logos.paymentMethods) && paymentMethods.length > 0 && logos.paymentMethods.length > 0;
    const showSocialMedia = !!socialMediaLinks && !!(logos === null || logos === void 0 ? void 0 : logos.socialMedia) && socialMediaLinks.length > 0 && logos.socialMedia.length > 0;
    const addressData = React.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const distanceDetails = React.useMemo(()=>storeDistanceConfig ? /*#__PURE__*/ React.createElement(StoreDistance, {
            code: code
        }) : null
    , [
        code,
        storeDistanceConfig
    ]);
    const labels = React.useMemo(()=>{
        const label = getFormattedLabel('stores.storeDetailsRoot.announcement', {
            hideLabelKey: true,
            parseLink: true
        });
        if (!label) {
            return {};
        }
        return {
            storeAnnouncement: label
        };
    }, [
        getFormattedLabel
    ]);
    var _bookAppointment, _bookAppointment1;
    return /*#__PURE__*/ React.createElement("article", {
        className: "store-details-stores-v2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__top-wrapper"
    }, preferredStoreUpdated ? /*#__PURE__*/ React.createElement(Alert, {
        type: preferredStoreSuccess ? 'success' : 'warning',
        icon: preferredStoreSuccess ? 'checkmark-circle' : 'warning',
        message: preferredStoreAlertLabel
    }) : null, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__top-row"
    }, breadcrumbs && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__breadcrumbs"
    }, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    })), breadcrumbs.length >= 2 && /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__breadcrumb"
    }, /*#__PURE__*/ React.createElement(SimpleBreadcrumb, {
        title: breadcrumbs[1].name,
        href: breadcrumbs[1].url
    }))), preferredStoreButton ? preferredStoreButton : null)), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__content-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__main-content-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__main-content"
    }, /*#__PURE__*/ React.createElement(StoreDetailImageContainer, {
        className: "store-details-stores-v2__detail-image",
        detailImageUrl: detailImage,
        fallbackImage: urls.storeFallbackImage,
        alt: shortName || name
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__contact-info"
    }, /*#__PURE__*/ React.createElement(Location, {
        className: "store-details-stores-v2__location",
        id: code,
        name: name,
        variant: Types.LocationVariant.StandAlone,
        emailAddress: emailAddress,
        phone: phone,
        emailHidden: hideEmail,
        phoneHidden: hidePhone,
        locationDetailsUrl: '',
        headerImage: activeCampaignBanner,
        highlight: false,
        addressData: addressData,
        addressSize: "COMPLETE",
        wheelchairAccessible: wheelchairAccessible,
        hearingAppointmentPossible: hearingAppointmentPossible,
        distanceDetails: distanceDetails,
        openingHours: /*#__PURE__*/ React.createElement(OpeningHours, {
            withTitle: true,
            announcement: storeNote,
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours,
            isExpandable: false,
            isExpanded: true
        }),
        buttons: /*#__PURE__*/ React.createElement(React.Fragment, null, showBookAppointmentDropInWidget ? /*#__PURE__*/ React.createElement("div", {
            className: "store-details-stores-v2__drop-in-widget-container",
            ref: dropInWidgetRef
        }, /*#__PURE__*/ React.createElement(DropInWidget, {
            urls: urls,
            storeId: code,
            typeId: appointmentTypeId,
            dataLayerEvents: {
                storeAppointmentClickEvent: 'storeDetailsFastAppointmentClick',
                storeChangeAppointmentTypeClickEvent: 'storeDetailsChangeClick'
            }
        })) : null, showBookAppointmentCTA ? /*#__PURE__*/ React.createElement("div", {
            ref: bookAppointmentButtonRef,
            className: "store-details-stores-v2__book-appointment"
        }, /*#__PURE__*/ React.createElement(StoreBookAppointmentCTAContainer, {
            url: (_bookAppointment = urls.bookAppointment) !== null && _bookAppointment !== void 0 ? _bookAppointment : '',
            code: code,
            name: name,
            town: town,
            country: country,
            streetName: streetName,
            streetNumber: streetNumber,
            additionalStreetInfo: additionalStreetInfo,
            postalCode: postalCode,
            appointmentTypeId: appointmentTypeId,
            storeCode: store.code
        })) : null, (showBookAppointmentDropInWidget || showBookAppointmentCTA) && labels.storeAnnouncement && /*#__PURE__*/ React.createElement(Text, {
            variant: "caption",
            children: labels.storeAnnouncement
        }))
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__secondary-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__location"
    }, /*#__PURE__*/ React.createElement(StoreLocationContainer, {
        opco: opco,
        code: code,
        name: name,
        town: town,
        province: province,
        country: country,
        streetName: streetName,
        streetNumber: streetNumber,
        additionalStreetInfo: additionalStreetInfo,
        postalCode: postalCode,
        lat: lat,
        lon: lon,
        distanceDetails: distanceDetails,
        practicalInformation: store.practicalInformation
    })), facilities && facilities.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__facilities"
    }, /*#__PURE__*/ React.createElement(StoreFacilitiesContainer, {
        facilities: facilities
    })), /*#__PURE__*/ React.createElement(StoreRatingContainer, {
        store: store
    }), offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffersContainer, {
        className: "store-details-stores-v2__store-offers",
        fallbackImage: urls.offerFallbackImage,
        offers: offers
    }), nearestStores.length > 0 && /*#__PURE__*/ React.createElement(NearbyStoresContainer, {
        className: "store-details-stores-v2__nearest-stores",
        stores: nearestStores,
        urls: urls,
        storeDetails: store
    }), storeCategories && storeCategories.length > 0 && /*#__PURE__*/ React.createElement(StoreCategoriesContainer, {
        className: "store-details-stores-v2__store-product-groups",
        fallbackImage: urls.productCategoryFallbackImage,
        storeCategories: storeCategories
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__description"
    }, /*#__PURE__*/ React.createElement(StoreDescriptionContainer, {
        storeName: name,
        description: description
    })), brands && brands.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__brands"
    }, /*#__PURE__*/ React.createElement(StoreBrandContainer, {
        brands: brands
    })), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__payment-methods-social-media"
    }, showPaymentMethods && !!logos && /*#__PURE__*/ React.createElement(StorePaymentMethodsContainer, {
        className: "store-details-stores-v2__payment-methods",
        logos: logos.paymentMethods,
        paymentMethods: paymentMethods
    }), showSocialMedia && !!logos && /*#__PURE__*/ React.createElement(StoreSocialMediaContainer, {
        className: "store-details-stores-v2__social-media",
        logos: logos.socialMedia,
        socialMediaLinks: socialMediaLinks
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__side-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__detail-image"
    }, /*#__PURE__*/ React.createElement(StoreDetailImageContainer, {
        detailImageUrl: detailImage,
        fallbackImage: urls.storeFallbackImage,
        alt: shortName || name
    })), /*#__PURE__*/ React.createElement(StoreRatingContainer, {
        store: store
    }), offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffersContainer, {
        className: "store-details-stores-v2__store-offers",
        fallbackImage: urls.offerFallbackImage,
        offers: offers
    }), nearestStores.length > 0 && /*#__PURE__*/ React.createElement(NearbyStoresContainer, {
        className: "store-details-stores-v2__nearest-stores",
        stores: nearestStores,
        urls: urls,
        storeDetails: store
    }), storeCategories && storeCategories.length > 0 && /*#__PURE__*/ React.createElement(StoreCategoriesContainer, {
        className: "store-details-stores-v2__store-product-groups",
        fallbackImage: urls.productCategoryFallbackImage,
        storeCategories: storeCategories
    }), showPaymentMethods && logos && /*#__PURE__*/ React.createElement(StorePaymentMethodsContainer, {
        logos: logos.paymentMethods,
        paymentMethods: paymentMethods
    }), showSocialMedia && logos && /*#__PURE__*/ React.createElement(StoreSocialMediaContainer, {
        logos: logos.socialMedia,
        socialMediaLinks: socialMediaLinks
    }))), showBookAppointmentCTA && /*#__PURE__*/ React.createElement("div", {
        "data-t": "cta-sticky-footer",
        className: classnames('store-details-stores-v2__sticky-footer', {
            'store-details-stores-v2__sticky-footer--hidden': hideStickyBookAppointmentButton
        })
    }, /*#__PURE__*/ React.createElement(StoreBookAppointmentCTAContainer, {
        url: (_bookAppointment1 = urls.bookAppointment) !== null && _bookAppointment1 !== void 0 ? _bookAppointment1 : '',
        code: code,
        name: name,
        town: town,
        country: country,
        streetName: streetName,
        streetNumber: streetNumber,
        additionalStreetInfo: additionalStreetInfo,
        postalCode: postalCode,
        appointmentTypeId: appointmentTypeId,
        storeCode: store.code
    })));
};

const StoresOverviewRoot = (_param)=>{
    var { storeGroups , storeLocatorURL , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeGroups",
        "storeLocatorURL",
        "className"
    ]);
    const onClick = React__default.useCallback((city)=>{
        const dataLayerEvent = storeGroupEvent({
            interaction: 'city click',
            step: 'store group overview',
            city
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, !!storeGroups && Object.keys(storeGroups).length > 0 ? /*#__PURE__*/ React__default.createElement("article", swcHelpers.extends({}, rest, {
        className: classnames('store-overview-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-overview-stores-v2__store-groups"
    }, Object.keys(storeGroups).map((groupName, index)=>{
        var ref;
         return React__default.createElement("div", {
            key: index,
            className: "store-overview-stores-v2__store-groups-item"
        }, /*#__PURE__*/ React__default.createElement("div", {
            className: "store-overview-stores-v2__store-groups-item-name-container"
        }, /*#__PURE__*/ React__default.createElement("p", {
            className: "store-overview-stores-v2__store-groups-item-name"
        }, groupName), /*#__PURE__*/ React__default.createElement(Hr, null)), (ref = storeGroups[groupName]) === null || ref === void 0 ? void 0 : ref.map((storeGroup)=>{
            const path = storeGroup.store ? `${storeLocatorURL}/${slugify(storeGroup.store.town)}/${storeGroup.store.slug || ''}` : `${storeLocatorURL}/${storeGroup.slug || ''}`;
            return /*#__PURE__*/ React__default.createElement("div", {
                key: storeGroup.name,
                className: "store-overview-stores-v2__store-groups-item-link-container"
            }, /*#__PURE__*/ React__default.createElement(Link, {
                onClick: ()=>onClick(storeGroup.name)
                ,
                url: path
            }, storeGroup.name));
        }));
    }))) : null);
};

const useBookAppointmentUrl = (baseUrl, store)=>{
    const { featureConfigs: { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } ,  } = useFeatureToggles();
    const bookAppointmentUrlProvider = getBookAppointmentUrl(baseUrl || '', {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    });
    return bookAppointmentUrlProvider(store);
};

const BookAppointmentButtonContainer = ({ store: store1 , view , baseUrl ,  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const bookAppointmentUrl = useBookAppointmentUrl(baseUrl, store1);
    const showBookAppointmentCTA = areServicesAvailable(store1, [
        Types$1.ServicesNotAvailable.APPOINTMENTS, 
    ]);
    const { code  } = store1;
    const onStoresLocatorResultEvent = React.useCallback(({ store , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onBookAppointmentButtonClickHandler = React.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'book appointment click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - book appointment',
            searchResults: stores.length
        });
        window.location.assign(bookAppointmentUrl);
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores,
        bookAppointmentUrl
    ]);
    if (!showBookAppointmentCTA) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: onBookAppointmentButtonClickHandler,
        variant: "solid",
        size: "small",
        "data-t": `book-appointment-${code}`,
        caption: getLabel('stores.page.storeGroup.action.bookAppointment')
    });
};

const StoreGroupFinderListItem = (_param)=>{
    var { className , store: { code , name , emailAddress , phone , storeDetailImage , openingHours , specialOpeningHours , storeNote , rating , wheelchairAccessible ,  } , showEmailAddress , showPhone , storeDetailsUrl , addressData , bookAppointmentButton , closeInfoWindow , onExpandOpeningHoursCallback , labels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "store",
        "showEmailAddress",
        "showPhone",
        "storeDetailsUrl",
        "addressData",
        "bookAppointmentButton",
        "closeInfoWindow",
        "onExpandOpeningHoursCallback",
        "labels"
    ]);
    const canShowEmailAddress = showEmailAddress && (emailAddress === null || emailAddress === void 0 ? void 0 : emailAddress.length);
    const canShowPhone = showPhone && phone.length;
    const canShowRating = typeof (rating === null || rating === void 0 ? void 0 : rating.value) === 'number';
    const canShowUrl = storeDetailsUrl === null || storeDetailsUrl === void 0 ? void 0 : storeDetailsUrl.length;
    return /*#__PURE__*/ React.createElement(StoreTile, swcHelpers.extends({
        id: code.toString()
    }, rest, {
        className: classnames('store-group-finder__item--list', className)
    }), storeDetailImage ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(StoreTileImage, {
        url: storeDetailImage
    })) : null, /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement(StoreTileSection, {
        asideSlot: wheelchairAccessible ? /*#__PURE__*/ React.createElement(Icon, {
            name: "wheelchair",
            "aria-label": labels === null || labels === void 0 ? void 0 : labels.wheelchairAccessible
        }) : null
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h3",
        className: "store-tile__typography-heading"
    }, canShowUrl ? /*#__PURE__*/ React.createElement(Link, {
        href: storeDetailsUrl,
        className: "store-group-finder__heading-link"
    }, name) : name))), /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: storeNote ? 'medium' : 'small'
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Address, {
        data: addressData,
        className: "store-group-finder__address--item"
    }, canShowEmailAddress || canShowPhone || canShowUrl || canShowRating ? /*#__PURE__*/ React.createElement("div", null, canShowPhone && /*#__PURE__*/ React.createElement(Text, {
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: `tel:${phone}`
    }, phone)), canShowEmailAddress && /*#__PURE__*/ React.createElement(Text, {
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: `mailto:${emailAddress}`
    }, emailAddress)), canShowUrl && /*#__PURE__*/ React.createElement(Text, {
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: storeDetailsUrl
    }, labels === null || labels === void 0 ? void 0 : labels.storeDetailsLink)), canShowRating && /*#__PURE__*/ React.createElement("div", {
        className: "store-rating"
    }, /*#__PURE__*/ React.createElement(Stars, {
        size: Sizes.small,
        color: Colors.black,
        className: "store-rating__stars",
        rating: rating.value,
        "aria-hidden": true
    }))) : null))), storeNote ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        message: storeNote,
        className: "store-group-finder__alert--item"
    })) : null, /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: bookAppointmentButton ? 'medium' : undefined
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "store-tile__typography-text",
        component: "div"
    }, /*#__PURE__*/ React.createElement(OpeningHours, {
        className: "store-group-finder__item-opening-hours--list",
        onExpandCallback: onExpandOpeningHoursCallback,
        openingHours: openingHours,
        specialOpeningHours: specialOpeningHours
    }))), bookAppointmentButton ? /*#__PURE__*/ React.createElement("footer", {
        className: "store-group-finder__item-footer"
    }, bookAppointmentButton) : null);
};

const StoreGroupFinderMapItem = (_param)=>{
    var { className , store: { code , name , emailAddress , phone , storeDetailImage , openingHours , specialOpeningHours , storeNote , wheelchairAccessible ,  } , showEmailAddress , showPhone , storeDetailsUrl , addressData , bookAppointmentButton , closeInfoWindow , labels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "store",
        "showEmailAddress",
        "showPhone",
        "storeDetailsUrl",
        "addressData",
        "bookAppointmentButton",
        "closeInfoWindow",
        "labels"
    ]);
    const canShowEmailAddress = showEmailAddress && emailAddress;
    const canShowPhone = showPhone && phone;
    const canShowUrl = storeDetailsUrl === null || storeDetailsUrl === void 0 ? void 0 : storeDetailsUrl.length;
    return /*#__PURE__*/ React.createElement(StoreTile, swcHelpers.extends({
        id: code.toString()
    }, rest, {
        className: classnames('store-group-finder__item--map', className)
    }), /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: storeDetailImage ? 'medium' : undefined,
        asideSlot: closeInfoWindow ? /*#__PURE__*/ React.createElement("button", {
            onClick: closeInfoWindow,
            type: "button"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "close"
        })) : null
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        component: "h3",
        className: "store-tile__typography-heading"
    }, canShowUrl ? /*#__PURE__*/ React.createElement(Link, {
        href: storeDetailsUrl,
        className: "store-group-finder__heading-link"
    }, name) : name))), storeDetailImage ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(StoreTileImage, {
        url: storeDetailImage,
        aspectRatio: "2/1"
    })) : null, /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: storeNote ? 'medium' : 'small',
        asideSlot: wheelchairAccessible ? /*#__PURE__*/ React.createElement(Icon, {
            name: "wheelchair",
            "aria-label": labels === null || labels === void 0 ? void 0 : labels.wheelchairAccessible
        }) : null
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Address, {
        data: addressData,
        className: "store-group-finder__address--item"
    }, canShowEmailAddress || canShowPhone || storeDetailsUrl ? /*#__PURE__*/ React.createElement("div", null, canShowPhone && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: `tel:${phone}`
    }, phone)), canShowEmailAddress && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: `mailto:${emailAddress}`
    }, emailAddress)), storeDetailsUrl && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: storeDetailsUrl
    }, labels === null || labels === void 0 ? void 0 : labels.storeDetailsLink))) : null))), storeNote ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        message: storeNote,
        className: "store-group-finder__alert--item"
    })) : null, /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: bookAppointmentButton ? 'medium' : undefined
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "div",
        className: "store-tile__typography-text"
    }, /*#__PURE__*/ React.createElement(OpeningHours, {
        openingHours: openingHours,
        specialOpeningHours: specialOpeningHours,
        isExpandable: false
    }))), bookAppointmentButton ? /*#__PURE__*/ React.createElement("footer", {
        className: "store-group-finder__item-footer"
    }, bookAppointmentButton) : null);
};

const StoreGroupFinderItemContainer = ({ className , store , loading , closeInfoWindow , onMouseEnter , onMouseLeave , urls , view ,  })=>{
    const { config , getStoreDetailsUrl  } = useStoreFinderContext();
    const { hideEmail , hidePhone  } = config;
    const { getLabel  } = useIntl();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province , country  } = store;
    const addressData = React.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province,
            country
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province,
        country
    ]);
    const labels = {
        wheelchairAccessible: getLabel('stores.page.details.wheelchairAccessible'),
        storeDetailsLink: getLabel('stores.page.storeGroup.action.storeDetails')
    };
    const storeDetailsUrl = getStoreDetailsUrl(store);
    const showBookAppointmentCTA = areServicesAvailable(store, [
        Types$1.ServicesNotAvailable.APPOINTMENTS, 
    ]);
    /**
   *  utilize google.maps.event.trigger(marker, 'mouseover');
   *
   *  Part of future refactor
   *  Story: GAAB-5320
   *  https://jira.grandvision.global/browse/GAAB-5320
   */ const onMouseEnterHandler = React.useCallback(()=>onMouseEnter && onMouseEnter(store)
    , [
        store,
        onMouseEnter
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>onMouseLeave && onMouseLeave(store)
    , [
        store,
        onMouseLeave
    ]);
    const StoreGroupFinderItem = view === 'map' ? StoreGroupFinderMapItem : StoreGroupFinderListItem;
    return /*#__PURE__*/ React.createElement(StoreGroupFinderItem, {
        className: className,
        closeInfoWindow: view === 'map' && isMobile ? closeInfoWindow : undefined,
        store: view === 'map' && isMobile ? swcHelpers.objectSpread({}, store, {
            storeDetailImage: undefined
        }) : store,
        addressData: addressData,
        showEmailAddress: !hideEmail,
        showPhone: !hidePhone,
        bookAppointmentButton: showBookAppointmentCTA ? /*#__PURE__*/ React.createElement(BookAppointmentButtonContainer, {
            view: view,
            store: store,
            baseUrl: urls === null || urls === void 0 ? void 0 : urls.bookAppointment
        }) : undefined,
        loading: loading,
        labels: labels,
        storeDetailsUrl: storeDetailsUrl,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler
    });
};

/**
 * I've chosen to create a StoreGroupFinderContainer instead of re-using the default StoreFinderContainer .
 * Ideally we would recreate a separate StoreFinderContainer for each use case.
 * This way we should have more control over the implementation.
 * We are actually already doing this, but the StoreFinderContainer is now becoming a mess
 * because it's reused for different purposes.
 */ const StoreGroupFinderContainer = ({ className , storeSearchFilters: propStoreSearchFilters , groupName , urls ,  })=>{
    const { getFormattedLabel  } = useIntl();
    const { isStoresLoading , stores , config , setHoveredStore  } = useStoreFinderContext();
    const [{ setFilterActivity , applyActiveFilters , clearAllFilters  }, { storeSearchFilters , storeSearchFilterList , hasActiveFilters , loading , activeFilters  }, ] = useStoreSearchFilters({
        filters: propStoreSearchFilters
    });
    const { googleMapsId  } = config;
    const prevActiveFilters = React.useRef([]);
    const showTabs = useTabs();
    /**
   *  Should be refactored and it shouldn't rely on state
   *  We should also utilize the Google Maps API to hover the Pin when hovering the list
   *
   *  Part of future refactor
   *  Story: GAAB-5320
   *  https://jira.grandvision.global/browse/GAAB-5320
   */ const onMouseEnterHandler = React.useCallback((store)=>setHoveredStore(store)
    , [
        setHoveredStore
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>setHoveredStore(null)
    , [
        setHoveredStore
    ]);
    const filteredStores = React.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    /**
   * I don't want to have this logic in this place, as it also lives in StoreFinderContainer
   * If we need to use it in both places, consider a better place
   * OR if there really is no other option: Convert it into a hook so it's easily re-usable.
   */ React.useEffect(()=>{
        if (prevActiveFilters.current.length !== activeFilters.length) {
            prevActiveFilters.current = activeFilters;
            const dataLayerEvent = storesSearchFilterEvent({
                activeFilters,
                searchResults: filteredStores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        activeFilters,
        filteredStores.length
    ]);
    // Add css variable var(--vh) to document
    useAddViewportHeightCssVariable();
    return /*#__PURE__*/ React.createElement(LocationSearch, {
        className: classnames('store-group-finder', className),
        googleMapsId: googleMapsId,
        showTabs: showTabs,
        searchForm: stores.length ? /*#__PURE__*/ React.createElement(StoreSearchFilters, {
            filters: storeSearchFilterList,
            setFilterActivity: setFilterActivity,
            className: "store-group-finder__search-filters"
        }) : null,
        listTopContent: /*#__PURE__*/ React.createElement(StoreListTopContent, {
            className: "store-group-finder__list-top-content",
            title: getFormattedLabel('stores.page.group.storeFinder.title', groupName ? {
                labelData: {
                    groupName
                }
            } : undefined),
            description: getFormattedLabel('stores.page.group.storeFinder.description', {
                hideLabelKey: true,
                labelData: {
                    storeCount: stores.length
                }
            })
        }),
        listInfoContent: /*#__PURE__*/ React.createElement(StoreFinderFilterWarning, {
            applyActiveFilters: applyActiveFilters,
            clearAllFilters: clearAllFilters,
            hasActiveFilters: hasActiveFilters
        }),
        loadingListItems: isStoresLoading,
        listItems: filteredStores.map((store)=>/*#__PURE__*/ React.createElement(StoreGroupFinderItemContainer, {
                loading: loading,
                key: store.code,
                store: store,
                onMouseEnter: onMouseEnterHandler,
                onMouseLeave: onMouseLeaveHandler,
                urls: urls,
                view: "list"
            })
        ),
        mapContent: /*#__PURE__*/ React.createElement(StoreFinderMapContainer, {
            stores: filteredStores,
            infoWindowContentComponent: (props)=>/*#__PURE__*/ React.createElement(StoreGroupFinderItemContainer, swcHelpers.extends({}, props, {
                    urls: urls,
                    view: "map"
                }))
        })
    });
};

const StoreGroupRoot = ({ groupName , hideEmail , hidePhone , stores , storeSearchFilters , urls ,  })=>{
    return /*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        initialStores: stores !== null && stores !== void 0 ? stores : undefined,
        urls: urls
    }, /*#__PURE__*/ React__default.createElement("style", {
        jsx: true,
        global: true
    }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `), /*#__PURE__*/ React__default.createElement(StoreGroupFinderContainer, {
        groupName: groupName,
        storeSearchFilters: storeSearchFilters,
        urls: urls
    }));
};

const StoresRoot = ({ urls , googleMapsId , hidePhone , hideEmail , storeSearchFilters , stores ,  })=>{
    const buttonsComponent = withDefaultButtonsConfig(DefaultButtonsContainer, {
        urls
    });
    return /*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: googleMapsId,
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        initialStores: stores,
        urls: urls
    }, /*#__PURE__*/ React__default.createElement("style", {
        jsx: true,
        global: true
    }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `), /*#__PURE__*/ React__default.createElement(StoreFinderContainer, {
        buttonsComponent: buttonsComponent,
        highlightPreferredStore: /*#__PURE__*/ React__default.createElement(HighlightPreferredStoreContainer$1, {
            buttonsComponent: buttonsComponent
        }),
        storeSearchFilters: storeSearchFilters
    }));
};

export { components as Components, containers as Containers, index$4 as DataLayer, index$3 as DetailsPage, index as GroupPage, index$5 as Hooks, StoreDetailsRoot, StoreFinderConsumer, StoreFinderProvider, StoreFinderSlotsProvider, StoreGroupRoot, index$1 as StoreSearchPage, index$2 as StoresOverviewPage, StoresOverviewRoot, StoresRoot, types as Types, index$6 as Util, storeFinderContextDefaultValues, useStoreFinderContext, useStoreFinderSlots };
//# sourceMappingURL=index.js.map
